import { useState } from 'react';
import poison from '@assets/poison_perfum.jpg';
import jordan22 from '@assets/jordan22.jpg';
import uxwrting from '@assets/uxwrting.jpg';
import landingpages from '@assets/landingpages.jpg';
import heros from '@assets/heros.jpg';
import content from '@assets/content.jpg';
import api from '@assets/api.jpg';
import python from '@assets/python.jpg';
import cybersecurity_AI from '@assets/cybersecurity_AI.png';
import techW from '@assets/techW.png';
import copyW from '@assets/copyW.png';
import emailM from '@assets/emailM.png';
import iphone16 from '@assets/iphone16.png';
import magazineW from '@assets/magazine_writers.png';
import fashionStories from '@assets/fashion_stories.jpg';
import lipstick from '@assets/lipstick.jpg';
import apps from '@assets/apps.jpg';
import pregnant from '@assets/pregnant.jpg';
import valentines from '@assets/valentines.jpg';
import portugal from '@assets/portugal.jpg';
import books from '@assets/booksweb.jpg';
import fashions from '@assets/fashionS.png';
import women_30 from '@assets/women_30.png';
import ai_not_creative from '@assets/ai_not_creative.png';
import your_story from '@assets/your_story.png';
import gemstonesblog from '@assets/gemstonesblog.jpg';
import gardenmag from '@assets/gardenmag.jpg';
import trust_copy from '@assets/trust_copy.jpg';
import futureinst from '@assets/futureinst.jpg';
import luxurymag from '@assets/luxurymag.jpg';
import women40_blog from '@assets/women40_blog.jpg';
import yourstory_blog from '@assets/yourstory_blog.jpg';
import blackwhite from '@assets/blackwhite.jpg';
import summertips from '@assets/summertips.jpg';
import watch from '@assets/watch.png';
import ageless from '@assets/ageless.png';
import collection from '@assets/collection.png';
import ads from '@assets/ads.png';
import symphony from '@assets/symphony.png';
import shape from '@assets/shape.png';
import over40 from '@assets/over40.png';
import abundance from '@assets/abundance.png';
import everyCEO from '@assets/everyCEO.png';
import rebuilding from '@assets/rebuilding.png';

import black_1 from '@assets/collection/black_1.png';
import black_2 from '@assets/collection/black_2.png';
import black_3 from '@assets/collection/black_3.png';
import black_4 from '@assets/collection/black_4.png';
import black_5 from '@assets/collection/black_5.png';
import black_6 from '@assets/collection/black_6.png';
import black_7 from '@assets/collection/black_7.png';
import black_8 from '@assets/collection/black_8.png';
import black_9 from '@assets/collection/black_9.png';
import black_10 from '@assets/collection/black_10.png';
import black_11 from '@assets/collection/black_11.png';
import black_12 from '@assets/collection/black_12.png';
import black_13 from '@assets/collection/black_13.png';
import black_14 from '@assets/collection/black_14.png';
import black_15 from '@assets/collection/black_15.png';
import black_16 from '@assets/collection/black_16.png';
import black_17 from '@assets/collection/black_17.png';
import black_18 from '@assets/collection/black_18.png';
import symphony_1 from '@assets/collection/symphony_1.png';
import symphony_2 from '@assets/collection/symphony_2.png';
import symphony_3 from '@assets/collection/symphony_3.png';
import symphony_4 from '@assets/collection/symphony_4.png';
import symphony_5 from '@assets/collection/symphony_5.png';
import symphony_6 from '@assets/collection/symphony_6.png';
import symphony_7 from '@assets/collection/symphony_7.png';
import symphony_8 from '@assets/collection/symphony_8.png';
import symphony_9 from '@assets/collection/symphony_9.png';
import symphony_10 from '@assets/collection/symphony_10.png';
import symphony_11 from '@assets/collection/symphony_11.png';
import symphony_12 from '@assets/collection/symphony_12.png';
import symphony_13 from '@assets/collection/symphony_13.png';
import symphony_14 from '@assets/collection/symphony_14.png';
import symphony_15 from '@assets/collection/symphony_15.png';
import symphony_16 from '@assets/collection/symphony_16.png';
import symphony_17 from '@assets/collection/symphony_17.png';
import symphony_18 from '@assets/collection/symphony_18.png';

import button_1 from '@assets/collection/button_1.png';
import button_2 from '@assets/collection/button_2.png';
import button_3 from '@assets/collection/button_3.png';
import button_4 from '@assets/collection/button_4.png';
import button_5 from '@assets/collection/button_5.png';
import button_6 from '@assets/collection/button_6.png';

import scandal from '@assets/scandal.png';
import lips from '@assets/lips.png';
import eyes from '@assets/eyes.png';
import bold from '@assets/bold.png';
import box from '@assets/box.png';
import elegance from '@assets/elegance.png';
import goldensea from '@assets/goldensea.png';
import nowords from '@assets/nowords.png';
import unlock from '@assets/unlock.png';
import diamond from '@assets/diamond.png';
import sophistication from '@assets/sophistication.png';
import white from '@assets/white.png';
import whitegold from '@assets/whitegold.png';
import fivestars from '@assets/fivestars.png';
import cosmetics from '@assets/cosmetics.png';
import business from '@assets/business.png';
import business_owner from '@assets/business_owner.png';
import red from '@assets/red.png';
import blue from '@assets/blue.png';
import isaiah from '@assets/isaiah.png';
import idea from '@assets/idea.png';
import life from '@assets/life.png';
import jesus from '@assets/jesus.png';
import lady_red from '@assets/lady_red.png';
import bible from '@assets/bible.png';
import lady_martins from '@assets/lady_martins.png';
import stone from '@assets/stone.png';
import rebecca from '@assets/rebecca.png';
import leather from '@assets/leather.png';
import alexandra from '@assets/alexandra.png';
import crystal from '@assets/crystal.png';
import dolphin from '@assets/dolphin.png';
import chanel5 from '@assets/chanel5.png';
import konova from '@assets/konova.png';
import redwhite from '@assets/redwhite.png';
import love from '@assets/love.png';
import makeup from '@assets/makeup.png';
import akchanel from '@assets/akchanel.png';
import dior from '@assets/dior.png';
import wines from '@assets/wines.png';
import ask from '@assets/ask.png';
import mask from '@assets/mask.png';
import jewe from '@assets/jewe.png';
import digitalM from '@assets/digitalM.png';
import game from '@assets/game.png';
import growth from '@assets/growth.png';
import possible from '@assets/possible.png';
import tango from '@assets/tango.png';
import eye from '@assets/eye.png';
import sighs from '@assets/sighs.png';
import style from '@assets/style.png';
import rapture from '@assets/rapture.png';
import coffee from '@assets/coffee.png';
import business_m from '@assets/business_m.png';
import closet from '@assets/closet.png';
import psalm30_5 from '@assets/psalm30_5.png';
import ebook_ad from '@assets/ebook_ad.png';
import power from '@assets/power.png';
import sevendays from '@assets/sevendays.png';
import strategy from '@assets/strategy.png';
import wakeup from '@assets/wakeup.png';
import thescent from '@assets/thescent.png';
import clothed from '@assets/clothed.png';
import comingsoon from '@assets/comingsoon.png';
import shelter from '@assets/shelter.png';
import whisper from '@assets/whisper.png';
import overcome from '@assets/overcome.png';
import techfashion from '@assets/techfashion.png';
import looks from '@assets/looks.png';
import endtimes from '@assets/endtimes.png';
import dress_well from '@assets/dress_well.png';
import waiting from '@assets/waiting.png';
import incase from '@assets/incase.png';
import theway from '@assets/theway.png';
import stage from '@assets/stage.png';
import timeup from '@assets/timeup.png';
import magazine from '@assets/magazine.png';
import blackandwhite from '@assets/blackandwhite.png';
import eternal from '@assets/eternal.png';
import privatejet from '@assets/privatejet.png';
import private_magazine from '@assets/private_magazine.png';
import miami from '@assets/miami.png';
import empire from '@assets/empire.png';
import manager from '@assets/manager.png';
import milliondollar from '@assets/milliondollar.png';
import ceo from '@assets/ceo.png';
import tweed from '@assets/tweed.png';
import movement from '@assets/movement.png';
import wardrobe_tweed from '@assets/wardrobe_tweed.png';
import silk from '@assets/silk.png';
import jeans from '@assets/jeans.png';
import watch_mt from '@assets/watch_mt.png';
import everything from '@assets/everything.png';
import final from '@assets/final.png';
import reason from '@assets/reason.png';
import brand from '@assets/brand.png';
import signature from '@assets/signature.png';
import despite from '@assets/despite.png';
import society from '@assets/society.png';
import sell from '@assets/sell.png';
import zone from '@assets/zone.png';
import story from '@assets/story.png';
import mentor from '@assets/mentor.png';
import vision from '@assets/vision.png';
import coaching from '@assets/coaching.png';
import coaching_cover from '@assets/ebooks/coaching_cover.png';
import expensive from '@assets/expensive.png';
import sevensigns from '@assets/sevensigns.png';
import colours from '@assets/colours.png';
import sit from '@assets/sit.png';
import breakthrough from '@assets/breakthrough.png';
import job from '@assets/job.png';
import wealth from '@assets/wealth.png';
import ceoSignature from '@assets/ceoSignature.png';
import gossip from '@assets/gossip.png';
import highheels from '@assets/highheels.png';
import way from '@assets/way.png';
import vera from '@assets/vera.png';
import plan from '@assets/plan.png';
import premium_power from '@assets/premium_power.png';
import second from '@assets/second.png';
import jumpsuit from '@assets/jumpsuit.png';
import babyborn from '@assets/babyborn.png';
import legacy from '@assets/legacy.png';
import imposter from '@assets/imposter.png';
import world_ceo from '@assets/world_ceo.png';
import jewish from '@assets/jewish.png';
import presents from '@assets/presents.png';
import martinshouse from '@assets/martinshouse.png';
import martins_christmas from '@assets/martins_christmas.png';
import asian from '@assets/asian.png';
import threesignature from '@assets/threesignature.png';
import strong from '@assets/strong.png';
import bestyear from '@assets/bestyear.png';
import nextchaper from '@assets/nextchaper.png';
import yourmask from '@assets/yourmask.png';
import blackceo from '@assets/blackceo.png';
import celebrateyourself from '@assets/celebrateyourself.png';
import agony from '@assets/agony.png';
import bounce_back from '@assets/bounce_back.png';
import leadership from '@assets/leadership.png';
import brandauthor from '@assets/brandauthor.png';
import shapeculture from '@assets/shapeculture.png';
import mondays from '@assets/mondays.png';
import wardrobe from '@assets/wardrobe.png';
import womenlife from '@assets/womenlife.png';
import command from '@assets/command.png';
import wears_magazine from '@assets/wears.png';
import week1_magazine from '@assets/week1.png';
import inside_magazine from '@assets/inside.png';
import investors_magazine from '@assets/investors.png';
import notblocked_magazine from '@assets/notblocked.png';
import purpose_magazine from '@assets/purpose.png';
import decode_magazine from '@assets/decode.png';
import likethem_magazine from '@assets/likethem.png';
import negotiation_magazine from '@assets/negotiation.png';
import notrends_magazine from'@assets/notrends.png';
import draft_magazine from '@assets/draft.png';
import shoesheels_magazine from '@assets/shoesheels.png';
import powerbrand_magazine from '@assets/powerbrand.png';
import weekIII_magazine from '@assets/weekIII.png';
import boundary_magazine from '@assets/boundary.png';
import contract_magazine from '@assets/contract_magazine.png';
import attract_magazine from '@assets/attract.png';
import jeansdemin_magazine from '@assets/jeansdenim.png';
import precision_magazine from '@assets/precision_magazine.png';
import positions_magazine from '@assets/positions.png';
import dontfail_magazine from '@assets/dontfail.png';
import blackandwhite_magazine from '@assets/blackandwhite_magazine.png';
import architecture_magazine from '@assets/architecture_magazine.png';
import mechanical_magazine from '@assets/mechanical_magazine.png';
import letterCEO_magazine from '@assets/letterCEO_magazine.png';
import burgundywhite_magazine from '@assets/burgundywhite_magazine.png';
import readingroom_magazine from '@assets/readingroom_magazine.png';
import privateuniform_magazine from '@assets/privateuniform_magazine.png';
import strongbrands_magazine from '@assets/strongbrands_magazine.png';
import institution_magazine from '@assets/institution_magazine.png';
import HighFashion_magazine from '@assets/HighFashion_magazine.png';
import waitingfor_magazine from '@assets/waitingfor_magazine.png';
import victory_magazine from '@assets/victory_magazine.png';
import pinkcard_magazine from '@assets/pinkcard_magazine.png';
import invisiblelogos_magazine from '@assets/invisiblelogos_magazine.png';
import survival_magazine from '@assets/survival_magazine.png';
import attraction_magazine from '@assets/attraction_magazine.png';
import weeksystem_magazine from '@assets/weeksystem_magazine.png';
import squareclassic_magazine from '@assets/squareclassic_magazine.png';
import atelier_magazine from '@assets/atelier_magazine.png';
import identity_magazine from '@assets/identity_magazine.png';
import lost_magazine from '@assets/lost_magazine.png';
import beginning_magazine from '@assets/beginning_magazine.png';
import covenantfashion_magazine from '@assets/covenantfashion_magazine.png';
import beyond_magazine from '@assets/beyond_magazine.png';
import whatchanges_magazine from '@assets/whatchanges_magazine.png';
import highnetworth_magazine from '@assets/highnetworth_magazine.png';
import changetime_magazine from '@assets/changetime_magazine.png';
import nextlevel_magazine from '@assets/nextlevel_magazine.png';
import wherfaith_magazine from '@assets/wherfaith_magazine.png';
import vitalidentity_magazine from '@assets/vitalidentity_magazine.png';
import behindpower_magazine from '@assets/behindpower_magazine.png';
import worldinfluence_magazine from '@assets/worldinfluence_magazine.png';
import everythingyou_magazine from '@assets/everythingyou_magazine.png';
import dontchace_magazine from '@assets/dontchace_magazine.png';
import thehat_magazine from '@assets/thehat_magazine.png';
import havevision_magazine from '@assets/havevision_magazine.png';
import beyondfashion_magazine from '@assets/beyondfashion_magazine.png';
import yoursuccess_magazine from '@assets/yoursuccess_magazine.png';
import privateissue_magazine from '@assets/privateissue_magazine.png';
import noteveryone_magazine from '@assets/noteveryone_magazine.png';
import luxurybags_magazine from '@assets/luxurybags_magazine.png';
import youarepowerful_magazine from '@assets/youarepowerful_magazine.png';
import InfluenceIsTailored_magazine from '@assets/InfluenceIsTailored_magazine.png';
import Cover_Cards_Magazine_Launch_magazine from '@assets/Cover_Cards_Magazine_Launch_magazine.png';
import The_Song_magazine from '@assets/The_Song_magazine.png';
import From_success_Sense_magazine from '@assets/From_success_Sense_magazine.png';
import Most_Powerful_Women_magazine from '@assets/Most_Powerful_Women_magazine.png';
import Where_Leadership_magazine from '@assets/Where_Leadership_magazine.png';
import New_Expression_magazine from '@assets/New_Expression_magazine.png';
import Strength_and_Elegance_magazine from '@assets/Strength_and_Elegance_magazine.png';
import Corporate_Authority_magazine from '@assets/Corporate_Authority_magazine.png';
import Prioritise_Leadership_magazine from '@assets/Prioritise_Leadership_magazine.png';
import Best_Women_magazine from '@assets/Best_Women_magazine.png';
import Signature_Series_magazine from '@assets/Signature_Series_magazine.png';
import Your_Signature_magazine from '@assets/Your_Signature_magazine.png';
import Get_Uncomfortable_magazine from '@assets/Get_Uncomfortable_magazine.png';
import Female_Empowerment_magazine from '@assets/Female_Empowerment_magazine.png';
import The_Business_Psychology_magazine from '@assets/The_Business_Psychology_magazine.png';
import Executive_Identity_Wear_magazine from '@assets/Executive_Identity_Wear_magazine.png';
import Executive_denim_magazine from '@assets/Executive_denim_magazine.png';
import Alexandra_Victor_magazine from '@assets/Alexandra_Victor_magazine.png';
import The_Executive_Woman_magazine from '@assets/The_Executive_Woman_magazine.png';
import The_Best_Perfume_magazine from '@assets/The_Best_Perfume_magazine.png';
import identity_coaching_magazine from '@assets/identity_coaching_magazine.png';
import The_woman_in_control_magazine from '@assets/The_woman_in_control_magazine.png';
import Sophisticated_makeup_magazine from '@assets/Sophisticated_makeup_magazine.png';
import Daniell_London_magazine from '@assets/Daniell_London_magazine.png';
import Elegance_Every_Move_magazine from '@assets/Elegance_Every_Move_magazine.png';
import Beyond_Styling_magazine from '@assets/Beyond_Styling_magazine.png';
import Cover_Luxury_Identity_Consultancy from '@assets/Cover_Luxury_Identity_Consultancy.png';
import We_Transform_Fashion_magazine from '@assets/We_Transform_Fashion_magazine.png';
import The_Future_of_Luxury_magazine from '@assets/The_Future_of_Luxury_magazine.png';
import Why_Successful_Founders_magazine from '@assets/Why_Successful_Founders_magazine.png';
import Cover_Luxury_Is_Not_Fashion from '@assets/Cover_Luxury_Is_Not_Fashion.png';
import Women_CEO_Next_Level_magazine from '@assets/Women_CEO_Next_Level_magazine.png';
import Cover_The_Cost3 from '@assets/Cover_The_Cost3.png';
import Cover_When_Success_Changes from '@assets/Cover_When_Success_Changes.png';
import Exceptional_Women_magazine from '@assets/Exceptional_Women_magazine.png';
import the_reason_magazine from '@assets/the_reason_magazine.png';
import Cover_Sillage from '@assets/Cover_Sillage.png';
import Your_Resume_magazine from '@assets/Your_Resume_magazine.png';
import Luxury_Price_magazine from '@assets/Luxury_Price_magazine.png';
import Luxury_business_magazine from '@assets/Luxury_business_magazine.png';
import Cover_The_Difference2 from '@assets/Cover_The_Difference2.png';
import Cover_Most_Businesses from '@assets/Cover_Most_Businesses.png';
import Cover_The_Wardrobe_of_Influence2 from '@assets/Cover_The_Wardrobe_of_Influence2.png';
import Luxury_Creativity_magazine from '@assets/Luxury_Creativity_magazine.png';
import Cover_Vision from '@assets/Cover_Vision.png';
import Cover_The_Most from '@assets/Cover_The_Most.png';
import Cover_Extravaganza from '@assets/Cover_Extravaganza.png';
import Cover2_Hides_Mysteries from '@assets/Cover2_Hides_Mysteries.jpg';
import Luxury_Begins_magazine from '@assets/Luxury_Begins_magazine.png';
import Cover_2_The_Architecture3 from '@assets/Cover_2_The_Architecture3.png';
import Cover_2_Decision_Fatigue3 from '@assets/Cover_2_Decision_Fatigue3.png';
import Cover_2_Hire_Creatives3 from '@assets/Cover_2_Hire_Creatives3.png';
import Cover_2_Code_Couture3 from '@assets/Cover_2_Code_Couture3.png';
import Cover_2_Agent_Blueprint3 from '@assets/Cover_2_Agent_Blueprint3.png';
import Cover_2_High_Ticket3 from '@assets/Cover_2_High_Ticket3.png';
import Cover_2_legacy_perfume from '@assets/Cover_2_legacy_perfume.png';
import Cover_2_Build_Legacies3 from '@assets/Cover_2_Build_Legacies3.png';
import Cover_2_Visual_Discretion3 from '@assets/Cover_2_Visual_Discretion3.png';
import Cover_2_Structural_Blueprint3 from '@assets/Cover_2_Structural_Blueprint3.png';
import Cover_2_Chanel_N5_4 from '@assets/Cover_2_Chanel_N5_4.png';
import Cover_2_Life_Hard3 from '@assets/Cover_2_Life_Hard3.png';
import Cover_2_Coco_Mademoiselle2 from '@assets/Cover_2_Coco_Mademoiselle2.png';
import Cover_2_Obsessed3 from '@assets/Cover_2_Obsessed3.png';
import Cover_2_joy5 from '@assets/Cover_2_joy5.png';
import Cover_2_Minimalist4 from '@assets/Cover_2_Minimalist4.png';
import Cover_2_Tolerance3 from '@assets/Cover_2_Tolerance3.png';
import Cover_2_Pardox3 from '@assets/Cover_2_Pardox3.png';
import Cover_2_Engineering_Identity3 from '@assets/Cover_2_Engineering_Identity3.png';
import Cover_2_YellowDark4 from '@assets/Cover_2_YellowDark4.png';
import Cover_2_JasminBag4 from '@assets/Cover_2_JasminBag4.png';
import Cover_2_Patek4 from '@assets/Cover_2_Patek4.png';
import Cover_2_Sandals3 from '@assets/Cover_2_Sandals3.png';
import Cover_2_life_walk3 from '@assets/Cover_2_life_walk3.png';
import Cover_2_portrait_lady5 from '@assets/Cover_2_portrait_lady5.png';
import Cover_2_Alignment3 from '@assets/Cover_2_Alignment3.png';
import Cover_2_Cipriani3 from '@assets/Cover_2_Cipriani3.png';
import Cover_2_Beyond_Luxury3 from '@assets/Cover_2_Beyond_Luxury3.png';
import Cover_2_Bob3 from '@assets/Cover_2_Bob3.png';
import Cover_2_prairie3 from '@assets/Cover_2_prairie3.png';
import Cover_2_Dress_Code3 from '@assets/Cover_2_Dress_Code3.png';
import Cover_2_Elite_Private from '@assets/Cover_2_Elite_Private.png';
import Cover_2_Libre3 from '@assets/Cover_2_Libre3.png';
import Cover_2_Protocol_DL3 from '@assets/Cover_2_Protocol_DL3.png';
import Cover_2_Global3 from '@assets/Cover_2_Global3.png';
import Cover_2_Executive_Wardrobe4 from '@assets/Cover_2_Executive_Wardrobe4.png';
import Cover_2_Executive_Handbag4 from '@assets/Cover_2_Executive_Handbag4.png';
import Cover_2_Franfance3 from '@assets/Cover_2_Franfance3.png';
import Cover_2_Coat3 from '@assets/Cover_2_Coat3.png';
import Cover_2_Errors3 from '@assets/Cover_2_Errors3.png';
import Cover_2_CEOBrand3 from '@assets/Cover_2_CEOBrand3.png';
import Cover_2_Prestige_Dior3 from '@assets/Cover_2_Prestige_Dior3.png';
import Cover_2_Yourself3 from '@assets/Cover_2_Yourself3.png';
import Cover_2_Between3 from '@assets/Cover_2_Between3.png';
import Cover_2_Details3 from '@assets/Cover_2_Details3.png';
import Cover_2_LaMaraina from '@assets/Cover_2_LaMaraina.png';
import Cover_2_Beyond_Price3 from '@assets/Cover_2_Beyond_Price3.png';
import Cover_2_Signature3 from '@assets/Cover_2_Signature3.png';
import Cover_2_HermesKelly3 from '@assets/Cover_2_HermesKelly3.png';
import Cover_2_Sketch3 from '@assets/Cover_2_Sketch3.png';
import Cover_2_Technical2 from '@assets/Cover_2_Technical2.png';
import Cover_2_Cuff3 from '@assets/Cover_2_Cuff3.png';
import Cover_2_services from '@assets/Cover_2_services.png';
import Cover_2_Luxury_Digital3 from '@assets/Cover_2_Luxury_Digital3.png';
import Cover_2_Collar4 from '@assets/Cover_2_Collar4.png';
import Cover_2_Decisions2 from '@assets/Cover_2_Decisions2.png';
import Cover_2_Clive3 from '@assets/Cover_2_Clive3.png';
import Cover_2_Beyond3 from '@assets/Cover_2_Beyond3.png';
import Cover_2_News_digital2 from '@assets/Cover_2_News_digital2.png';

import fashion_edition_1 from '@assets/ebooks/fashion_edition_1.png';
import fashion_edition_2 from '@assets/ebooks/fashion_edition_2.png';
import fashion_edition_3 from '@assets/ebooks/fashion_edition_3.png';
import fashion_edition_4 from '@assets/ebooks/fashion_edition_4.png';
import beauty_edition_1 from '@assets/ebooks/beauty_edition_1.png';

import one from '@assets/ebooks/fashion_edition_1/one.png';
import two from '@assets/ebooks/fashion_edition_1/two.png';
import three from '@assets/ebooks/fashion_edition_1/three.png';
import four from '@assets/ebooks/fashion_edition_1/four.png';
import five from '@assets/ebooks/fashion_edition_1/five.png';

import article_22 from '@assets/ebooks/article_22.png';
import article_23 from '@assets/ebooks/article_23.png';
import article_24 from '@assets/ebooks/article_24.png';
import article_25 from '@assets/ebooks/article_25.png';
import article_26 from '@assets/ebooks/article_26.png';
import article_27 from '@assets/ebooks/article_27.png';
import article_28 from '@assets/ebooks/article_28.png';
import article_29 from '@assets/ebooks/article_29.png';
import article_30 from '@assets/ebooks/article_30.png';

import orange_1 from '@assets/collection/orange_1.png';
import orange_2 from '@assets/collection/orange_2.png';
import orange_3 from '@assets/collection/orange_3.png';
import orange_4 from '@assets/collection/orange_4.png';
import orange_5 from '@assets/collection/orange_5.png';
import orange_6 from '@assets/collection/orange_6.png';
import orange_7 from '@assets/collection/orange_7.png';
import orange_8 from '@assets/collection/orange_8.png';

import spring_1 from '@assets/collection/spring_1.png';
import spring_2 from '@assets/collection/spring_2.png';
import spring_3 from '@assets/collection/spring_3.png';
import spring_4 from '@assets/collection/spring_4.png';
import spring_5 from '@assets/collection/spring_5.png';
import spring_6 from '@assets/collection/spring_6.png';

import gold_1 from '@assets/collection/gold_1.png';
import gold_2 from '@assets/collection/gold_2.png';
import gold_3 from '@assets/collection/gold_3.png';
import gold_4 from '@assets/collection/gold_4.png';
import gold_5 from '@assets/collection/gold_5.png';
import gold_6 from '@assets/collection/gold_6.png';
import gold_7 from '@assets/collection/gold_7.png';
import gold_8 from '@assets/collection/gold_8.png';
import gold_9 from '@assets/collection/gold_9.png';
import gold_10 from '@assets/collection/gold_10.png';
import gold_11 from '@assets/collection/gold_11.png';
import gold_12 from '@assets/collection/gold_12.png';
import gold_13 from '@assets/collection/gold_13.png';
import gold_14 from '@assets/collection/gold_14.png';
import gold_15 from '@assets/collection/gold_15.png';
import gold_16 from '@assets/collection/gold_16.png';
import gold_17 from '@assets/collection/gold_17.png';
import gold_18 from '@assets/collection/gold_18.png';
import gold_19 from '@assets/collection/gold_19.png';
import gold_20 from '@assets/collection/gold_20.png';
import gold_21 from '@assets/collection/gold_21.png';
import gold_22 from '@assets/collection/gold_22.png';
import gold_23 from '@assets/collection/gold_23.png';

import gold_24 from '@assets/collection/gold_24.png';
import gold_25 from '@assets/collection/gold_25.png';
import gold_26 from '@assets/collection/gold_26.png';
import gold_27 from '@assets/collection/gold_27.png';
import gold_28 from '@assets/collection/gold_28.png';
import gold_29 from '@assets/collection/gold_29.png';
import gold_30 from '@assets/collection/gold_30.png';
import gold_31 from '@assets/collection/gold_31.png';
import gold_32 from '@assets/collection/gold_32.png';
import gold_33 from '@assets/collection/gold_33.png';
import gold_34 from '@assets/collection/gold_34.png';
import gold_35 from '@assets/collection/gold_35.png';

import diamond_1 from '@assets/collection/diamond_1.png';
import diamond_2 from '@assets/collection/diamond_2.png';
import diamond_3 from '@assets/collection/diamond_3.png';
import diamond_4 from '@assets/collection/diamond_4.png';
import diamond_5 from '@assets/collection/diamond_5.png';
import diamond_6 from '@assets/collection/diamond_6.png';

import yellow_1 from '@assets/collection/yellow_1.png';
import yellow_2 from '@assets/collection/yellow_2.png';
import yellow_3 from '@assets/collection/yellow_3.png';
import yellow_4 from '@assets/collection/yellow_4.png';
import yellow_5 from '@assets/collection/yellow_5.png';
import yellow_6 from '@assets/collection/yellow_6.png';
import yellow_7 from '@assets/collection/yellow_7.png';
import yellow_8 from '@assets/collection/yellow_8.png';
import yellow_9 from '@assets/collection/yellow_9.png';
import yellow_10 from '@assets/collection/yellow_10.png';
import yellow_11 from '@assets/collection/yellow_11.png';

import white_1 from '@assets/collection/white_1.png';
import white_2 from '@assets/collection/white_2.png';
import white_3 from '@assets/collection/white_3.png';
import white_4 from '@assets/collection/white_4.png';
import white_5 from '@assets/collection/white_5.png';
import white_6 from '@assets/collection/white_6.png';
import white_7 from '@assets/collection/white_7.png';
import white_8 from '@assets/collection/white_8.png';
import white_9 from '@assets/collection/white_9.png';
import white_10 from '@assets/collection/white_10.png';
import white_11 from '@assets/collection/white_11.png';
import white_12 from '@assets/collection/white_12.png';

import blue_1 from '@assets/collection/blue_1.png';
import blue_2 from '@assets/collection/blue_2.png';
import blue_3 from '@assets/collection/blue_3.png';
import blue_4 from '@assets/collection/blue_4.png';
import blue_5 from '@assets/collection/blue_5.png';

import ladyRed_1 from '@assets/collection/ladyRed_1.png';
import ladyRed_2 from '@assets/collection/ladyRed_2.png';
import ladyRed_3 from '@assets/collection/ladyRed_3.png';
import ladyRed_4 from '@assets/collection/ladyRed_4.png';
import ladyRed_5 from '@assets/collection/ladyRed_5.png';
import ladyRed_6 from '@assets/collection/ladyRed_6.png';
import ladyRed_7 from '@assets/collection/ladyRed_7.png';
import ladyRed_8 from '@assets/collection/ladyRed_8.png';
import ladyRed_9 from '@assets/collection/ladyRed_9.png';
import ladyRed_10 from '@assets/collection/ladyRed_10.png';

import entre_1 from '@assets/collection/entre_1.png';
import entre_2 from '@assets/collection/entre_2.png';
import entre_3 from '@assets/collection/entre_3.png';
import entre_4 from '@assets/collection/entre_4.png';
import entre_5 from '@assets/collection/entre_5.png';
import entre_6 from '@assets/collection/entre_6.png';
import entre_7 from '@assets/collection/entre_7.png';
import entre_8 from '@assets/collection/entre_8.png';
import entre_9 from '@assets/collection/entre_9.png';
import entre_10 from '@assets/collection/entre_10.png';
import entre_11 from '@assets/collection/entre_11.png';
import entre_12 from '@assets/collection/entre_12.png';
import entre_13 from '@assets/collection/entre_13.png';
import entre_14 from '@assets/collection/entre_14.png';
import entre_15 from '@assets/collection/entre_15.png';
import entre_16 from '@assets/collection/entre_16.png';
import entre_17 from '@assets/collection/entre_17.png';
import entre_18 from '@assets/collection/entre_18.png';
import entre_19 from '@assets/collection/entre_19.png';
import entre_20 from '@assets/collection/entre_20.png';
import entre_21 from '@assets/collection/entre_21.png';
import entre_22 from '@assets/collection/entre_22.png';
import entre_23 from '@assets/collection/entre_23.png';
import entre_24 from '@assets/collection/entre_24.png';
import entre_25 from '@assets/collection/entre_25.png';
import entre_26 from '@assets/collection/entre_26.png';
import entre_27 from '@assets/collection/entre_27.png';
import entre_28 from '@assets/collection/entre_28.png';
import entre_29 from '@assets/collection/entre_29.png';
import entre_30 from '@assets/collection/entre_30.png';
import entre_31 from '@assets/collection/entre_31.png';
import entre_32 from '@assets/collection/entre_32.png';
import entre_33 from '@assets/collection/entre_33.png';
import entre_34 from '@assets/collection/entre_34.png';
import entre_35 from '@assets/collection/entre_35.png';

import lth_1 from '@assets/collection/lth_1.png';
import lth_2 from '@assets/collection/lth_2.png';
import lth_3 from '@assets/collection/lth_3.png';
import lth_4 from '@assets/collection/lth_4.png';
import lth_5 from '@assets/collection/lth_5.png';
import lth_6 from '@assets/collection/lth_6.png';
import lth_7 from '@assets/collection/lth_7.png';
import lth_8 from '@assets/collection/lth_8.png';
import lth_9 from '@assets/collection/lth_9.png';
import lth_10 from '@assets/collection/lth_10.png';
import lth_11 from '@assets/collection/lth_11.png';
import lth_12 from '@assets/collection/lth_12.png';
import lth_13 from '@assets/collection/lth_13.png';

import mask_1 from '@assets/collection/mask_1.png';
import mask_2 from '@assets/collection/mask_2.png';
import mask_3 from '@assets/collection/mask_3.png';
import mask_4 from '@assets/collection/mask_4.png';
import mask_5 from '@assets/collection/mask_5.png';
import mask_6 from '@assets/collection/mask_6.png';
import mask_7 from '@assets/collection/mask_7.png';
import mask_8 from '@assets/collection/mask_8.png';
import mask_9 from '@assets/collection/mask_9.png';
import mask_10 from '@assets/collection/mask_10.png';
import mask_11 from '@assets/collection/mask_11.png';
import mask_12 from '@assets/collection/mask_12.png';
import mask_13 from '@assets/collection/mask_13.png';
import mask_14 from '@assets/collection/mask_14.png';

import tango_1 from '@assets/collection/tango_1.png';
import tango_2 from '@assets/collection/tango_2.png';
import tango_3 from '@assets/collection/tango_3.png';
import tango_4 from '@assets/collection/tango_4.png';
import tango_5 from '@assets/collection/tango_5.png';
import tango_6 from '@assets/collection/tango_6.png';
import tango_7 from '@assets/collection/tango_7.png';
import tango_8 from '@assets/collection/tango_8.png';
import tango_9 from '@assets/collection/tango_9.png';
import tango_10 from '@assets/collection/tango_10.png';
import tango_11 from '@assets/collection/tango_11.png';
import tango_12 from '@assets/collection/tango_12.png';

import tango_13 from '@assets/collection/tango_13.png';
import tango_14 from '@assets/collection/tango_14.png';
import tango_15 from '@assets/collection/tango_15.png';
import tango_16 from '@assets/collection/tango_16.png';
import tango_17 from '@assets/collection/tango_17.png';

import collection1 from '@assets/collection/collection/collection_1.png';
import collection2 from '@assets/collection/collection/collection_2.png';
import collection3 from '@assets/collection/collection/collection_3.png';
import collection4 from '@assets/collection/collection/collection_4.png';
import collection5 from '@assets/collection/collection/collection_5.png';
import collection6 from '@assets/collection/collection/collection_6.png';
import collection7 from '@assets/collection/collection/collection_7.png';
import collection8 from '@assets/collection/collection/collection_8.png';
import collection9 from '@assets/collection/collection/collection_9.png';
import collection10 from '@assets/collection/collection/collection_10.png';
import collection11 from '@assets/collection/collection/collection_11.png';
import collection12 from '@assets/collection/collection/collection_12.png';
import collection13 from '@assets/collection/collection/collection_13.png';
import collection14 from '@assets/collection/collection/collection_14.png';
import collection15 from '@assets/collection/collection/collection_15.png';
import collection16 from '@assets/collection/collection/collection_16.png';
import collection17 from '@assets/collection/collection/collection_17.png';
import collection18 from '@assets/collection/collection/collection_18.png';
import collection19 from '@assets/collection/collection/collection_19.png';
import collection20 from '@assets/collection/collection/collection_20.png';
import collection21 from '@assets/collection/collection/collection_21.png';
import collection22 from '@assets/collection/collection/collection_22.png';
import collection23 from '@assets/collection/collection/collection_23.png';
import collection24 from '@assets/collection/collection/collection_24.png';
import collection25 from '@assets/collection/collection/collection_25.png';
import collection26 from '@assets/collection/collection/collection_26.png';
import collection27 from '@assets/collection/collection/collection_27.png';
import collection28 from '@assets/collection/collection/collection_28.png';
import collection29 from '@assets/collection/collection/collection_29.png';
import collection30 from '@assets/collection/collection/collection_30.png';
import collection31 from '@assets/collection/collection/collection_31.png';
import collection32 from '@assets/collection/collection/collection_32.png';
import collection33 from '@assets/collection/collection/collection_33.png';
import collection34 from '@assets/collection/collection/collection_34.png';
import collection35 from '@assets/collection/collection/collection_35.png';
import collection36 from '@assets/collection/collection/collection_36.png';
import collection37 from '@assets/collection/collection/collection_37.png';
import collection38 from '@assets/collection/collection/collection_38.png';
import collection39 from '@assets/collection/collection/collection_39.png';
import collection40 from '@assets/collection/collection/collection_40.png';
import collection41 from '@assets/collection/collection/collection_41.png';
import collection42 from '@assets/collection/collection/collection_42.png';
import collection43 from '@assets/collection/collection/collection_43.png';
import collection44 from '@assets/collection/collection/collection_44.png';
import collection45 from '@assets/collection/collection/collection_45.png';
import collection46 from '@assets/collection/collection/collection_46.png';
import collection47 from '@assets/collection/collection/collection_47.png';
import collection48 from '@assets/collection/collection/collection_48.png';
import collection49 from '@assets/collection/collection/collection_49.png';
import collection50 from '@assets/collection/collection/collection_50.png';
import collection51 from '@assets/collection/collection/collection_51.png';
import collection52 from '@assets/collection/collection/collection_52.png';
import collection53 from '@assets/collection/collection/collection_53.png';
import collection54 from '@assets/collection/collection/collection_54.png';
import collection55 from '@assets/collection/collection/collection_55.png';
import collection56 from '@assets/collection/collection/collection_56.png';

import collectionj1 from '@assets/collection/collection/collection_j1.png';
import collectionj2 from '@assets/collection/collection/collection_j2.png';
import collectionj3 from '@assets/collection/collection/collection_j3.png';
import collectionj4 from '@assets/collection/collection/collection_j4.png';
import collectionj5 from '@assets/collection/collection/collection_j5.png';
import collectionj6 from '@assets/collection/collection/collection_j6.png';
import collectionj7 from '@assets/collection/collection/collection_j7.png';
import collectionj8 from '@assets/collection/collection/collection_j8.png';
import collectionj9 from '@assets/collection/collection/collection_j9.png';
import collectionj10 from '@assets/collection/collection/collection_j10.png';
import collectionj11 from '@assets/collection/collection/collection_j11.png';
import collectionj12 from '@assets/collection/collection/collection_j12.png';
import collectionj13 from '@assets/collection/collection/collection_j13.png';
import collectionj14 from '@assets/collection/collection/collection_j14.png';
import collectionj15 from '@assets/collection/collection/collection_j15.png';
import collectionj16 from '@assets/collection/collection/collection_j16.png';
import collectionj17 from '@assets/collection/collection/collection_j17.png';
import collectionj18 from '@assets/collection/collection/collection_j18.png';
import collectionj19 from '@assets/collection/collection/collection_j19.png';
import collectionj20 from '@assets/collection/collection/collection_j20.png';

import CEO1 from '@assets/collection/collection/CEO_1.png';
import CEO2 from '@assets/collection/collection/CEO_2.png';
import CEO3 from '@assets/collection/collection/CEO_3.png';
import CEO4 from '@assets/collection/collection/CEO_4.png';
import CEO5 from '@assets/collection/collection/CEO_5.png';
import CEO6 from '@assets/collection/collection/CEO_6.png';
import CEO7 from '@assets/collection/collection/CEO_7.png';
import CEO8 from '@assets/collection/collection/CEO_8.png';
import CEO9 from '@assets/collection/collection/CEO_9.png';
import CEO10 from '@assets/collection/collection/CEO_10.png';
import CEO11 from '@assets/collection/collection/CEO_11.png';
import CEO12 from '@assets/collection/collection/CEO_12.png';
import CEO13 from '@assets/collection/collection/CEO_13.png';
import CEO14 from '@assets/collection/collection/CEO_14.png';
import CEO15 from '@assets/collection/collection/CEO_15.png';
import CEO16 from '@assets/collection/collection/CEO_16.png';
import CEO17 from '@assets/collection/collection/CEO_17.png';
import CEO18 from '@assets/collection/collection/CEO_18.png';
import CEO19 from '@assets/collection/collection/CEO_19.png';
import CEO20 from '@assets/collection/collection/CEO_20.png';

import asian1 from '@assets/collection/collection/asian_collection1.png';
import asian2 from '@assets/collection/collection/asian_collection2.png';
import asian3 from '@assets/collection/collection/asian_collection3.png';
import asian4 from '@assets/collection/collection/asian_collection4.png';
import asian5 from '@assets/collection/collection/asian_collection5.png';
import asian6 from '@assets/collection/collection/asian_collection6.png';
import asian7 from '@assets/collection/collection/asian_collection7.png';
import asian8 from '@assets/collection/collection/asian_collection8.png';
import asian9 from '@assets/collection/collection/asian_collection9.png';
import asian10 from '@assets/collection/collection/asian_collection10.png';
import asian11 from '@assets/collection/collection/asian_collection11.png';
import asian12 from '@assets/collection/collection/asian_collection12.png';
import asian13 from '@assets/collection/collection/asian_collection13.png';
import asian14 from '@assets/collection/collection/asian_collection14.png';
import asian15 from '@assets/collection/collection/asian_collection15.png';
import asian16 from '@assets/collection/collection/asian_collection16.png';

import stripes1 from '@assets/collection/collection/stripes_1.png';
import stripes2 from '@assets/collection/collection/stripes_2.png';
import stripes3 from '@assets/collection/collection/stripes_3.png';
import stripes4 from '@assets/collection/collection/stripes_4.png';
import stripes5 from '@assets/collection/collection/stripes_5.png';
import stripes6 from '@assets/collection/collection/stripes_6.png';
import stripes7 from '@assets/collection/collection/stripes_7.png';
import stripes8 from '@assets/collection/collection/stripes_8.png';
import stripes9 from '@assets/collection/collection/stripes_9.png';
import stripes10 from '@assets/collection/collection/stripes_10.png';
import stripes11 from '@assets/collection/collection/stripes_11.png';
import stripes12 from '@assets/collection/collection/stripes_12.png';
import stripes13 from '@assets/collection/collection/stripes_13.png';
import stripes14 from '@assets/collection/collection/stripes_14.png';
import stripes15 from '@assets/collection/collection/stripes_15.png';
import stripes16 from '@assets/collection/collection/stripes_16.png';
import stripes17 from '@assets/collection/collection/stripes_17.png';
import stripes18 from '@assets/collection/collection/stripes_18.png';

import FL1 from '@assets/collection/collection/FL1.png';
import FL2 from '@assets/collection/collection/FL2.png';
import FL3 from '@assets/collection/collection/FL3.png';
import FL5 from '@assets/collection/collection/FL5.png';
import FL6 from '@assets/collection/collection/FL6.png';
import FL7 from '@assets/collection/collection/FL7.png';
import FL8 from '@assets/collection/collection/FL8.png';
import FL9 from '@assets/collection/collection/FL9.png';
import FL10 from '@assets/collection/collection/FL10.png';

import JFL1 from '@assets/collection/collection/JFL1.png';
import JFL2 from '@assets/collection/collection/JFL2.png';
import JFL3 from '@assets/collection/collection/JFL3.png';
import JFL4 from '@assets/collection/collection/JFL4.png';

import th1 from '@assets/collection/collection/th1.png';
import th2 from '@assets/collection/collection/th2.png';
import th3 from '@assets/collection/collection/th3.png';
import th4 from '@assets/collection/collection/th4.png';
import th5 from '@assets/collection/collection/th5.png';
import th6 from '@assets/collection/collection/th6.png';
import th7 from '@assets/collection/collection/th7.png';
import th8 from '@assets/collection/collection/th8.png';
import th9 from '@assets/collection/collection/th9.png';
import th10 from '@assets/collection/collection/th10.png';
import th11 from '@assets/collection/collection/th11.png';
import th12 from '@assets/collection/collection/th12.png';
import th13 from '@assets/collection/collection/th13.png';
import th14 from '@assets/collection/collection/th14.png';
import th15 from '@assets/collection/collection/th15.png';
import th16 from '@assets/collection/collection/th16.png';
import th17 from '@assets/collection/collection/th17.png';
import th18 from '@assets/collection/collection/th18.png';
import th19 from '@assets/collection/collection/th19.png';
import th20 from '@assets/collection/collection/th20.png';

import private1 from '@assets/collection/collection/thmartins/private1.png';
import private2 from '@assets/collection/collection/thmartins/private2.png';
import private3 from '@assets/collection/collection/thmartins/private3.png';
import private4 from '@assets/collection/collection/thmartins/private4.png';
import private5 from '@assets/collection/collection/thmartins/private5.png';
import private6 from '@assets/collection/collection/thmartins/private6.png';
import private7 from '@assets/collection/collection/thmartins/private7.png';
import private8 from '@assets/collection/collection/thmartins/private8.png';
import private9 from '@assets/collection/collection/thmartins/private9.png';
import private10 from '@assets/collection/collection/thmartins/private10.png';
import private11 from '@assets/collection/collection/thmartins/private11.png';
import private12 from '@assets/collection/collection/thmartins/private12.png';
import private13 from '@assets/collection/collection/thmartins/private13.png';
import private14 from '@assets/collection/collection/thmartins/private14.png';
import private15 from '@assets/collection/collection/thmartins/private15.png';
import private16 from '@assets/collection/collection/thmartins/private16.png';
import private17 from '@assets/collection/collection/thmartins/private17.png';
import private18 from '@assets/collection/collection/thmartins/private18.png';
import private19 from '@assets/collection/collection/thmartins/private19.png';
import private20 from '@assets/collection/collection/thmartins/private20.png';
import private21 from '@assets/collection/collection/thmartins/private21.png';
import private22 from '@assets/collection/collection/thmartins/private22.png';
import private23 from '@assets/collection/collection/thmartins/private23.png';
import private24 from '@assets/collection/collection/thmartins/private24.png';
import private25 from '@assets/collection/collection/thmartins/private25.png';
import private26 from '@assets/collection/collection/thmartins/private26.png';
import private27 from '@assets/collection/collection/thmartins/private27.png';
import private28 from '@assets/collection/collection/thmartins/private28.png';
import private29 from '@assets/collection/collection/thmartins/private29.png';
import private30 from '@assets/collection/collection/thmartins/private30.png';

import private31 from '@assets/collection/collection/thmartins/private31.png';
import private32 from '@assets/collection/collection/thmartins/private32.png';
import private33 from '@assets/collection/collection/thmartins/private33.png';
import private34 from '@assets/collection/collection/thmartins/private34.png';
import private35 from '@assets/collection/collection/thmartins/private35.png';
import private36 from '@assets/collection/collection/thmartins/private36.png';
import private37 from '@assets/collection/collection/thmartins/private37.png';
import private38 from '@assets/collection/collection/thmartins/private38.png';
import private39 from '@assets/collection/collection/thmartins/private39.png';
import private40 from '@assets/collection/collection/thmartins/private40.png';
import private41 from '@assets/collection/collection/thmartins/private41.png';
import private42 from '@assets/collection/collection/thmartins/private42.png';
import private43 from '@assets/collection/collection/thmartins/private43.png';
import private44 from '@assets/collection/collection/thmartins/private44.png';
import private45 from '@assets/collection/collection/thmartins/private45.png';
import private46 from '@assets/collection/collection/thmartins/private46.png';
import private47 from '@assets/collection/collection/thmartins/private47.png';
import private48 from '@assets/collection/collection/thmartins/private48.png';
import private49 from '@assets/collection/collection/thmartins/private49.png';
import private50 from '@assets/collection/collection/thmartins/private50.png';

import contract1 from '@assets/collection/collection/thmartins/contract1.png';
import contract2 from '@assets/collection/collection/thmartins/contract2.png';
import contract3 from '@assets/collection/collection/thmartins/contract3.png';
import contract4 from '@assets/collection/collection/thmartins/contract4.png';
import contract5 from '@assets/collection/collection/thmartins/contract5.png';
import contract6 from '@assets/collection/collection/thmartins/contract6.png';
import contract7 from '@assets/collection/collection/thmartins/contract7.png';
import contract8 from '@assets/collection/collection/thmartins/contract8.png';
import contract9 from '@assets/collection/collection/thmartins/contract9.png';
import contract10 from '@assets/collection/collection/thmartins/contract10.png';

import jeans1 from '@assets/collection/collection/thmartins/jeans1.png';
import jeans2 from '@assets/collection/collection/thmartins/jeans2.png';
import jeans3 from '@assets/collection/collection/thmartins/jeans3.png';
import jeans4 from '@assets/collection/collection/thmartins/jeans4.png';
import jeans5 from '@assets/collection/collection/thmartins/jeans5.png';
import jeans6 from '@assets/collection/collection/thmartins/jeans6.png';
import jeans7 from '@assets/collection/collection/thmartins/jeans7.png';
import jeans8 from '@assets/collection/collection/thmartins/jeans8.png';
import jeans9 from '@assets/collection/collection/thmartins/jeans9.png';
import jeans10 from '@assets/collection/collection/thmartins/jeans10.png';

import blackwhite1 from '@assets/collection/collection/thmartins/blackwhite1.png';
import blackwhite2 from '@assets/collection/collection/thmartins/blackwhite2.png';
import blackwhite3 from '@assets/collection/collection/thmartins/blackwhite3.png';
import blackwhite4 from '@assets/collection/collection/thmartins/blackwhite4.png';
import blackwhite5 from '@assets/collection/collection/thmartins/blackwhite5.png';
import blackwhite6 from '@assets/collection/collection/thmartins/blackwhite6.png';
import blackwhite7 from '@assets/collection/collection/thmartins/blackwhite7.png';
import blackwhite8 from '@assets/collection/collection/thmartins/blackwhite8.png';
import blackwhite9 from '@assets/collection/collection/thmartins/blackwhite9.png';
import blackwhite10 from '@assets/collection/collection/thmartins/blackwhite10.png';
import blackwhite11 from '@assets/collection/collection/thmartins/blackwhite11.png';
import blackwhite12 from '@assets/collection/collection/thmartins/blackwhite12.png';
import blackwhite13 from '@assets/collection/collection/thmartins/blackwhite13.png';
import blackwhite14 from '@assets/collection/collection/thmartins/blackwhite14.png';
import blackwhite15 from '@assets/collection/collection/thmartins/blackwhite15.png';

import burgundywhite1 from '@assets/collection/collection/thmartins/burgundywhite1.png';
import burgundywhite2 from '@assets/collection/collection/thmartins/burgundywhite2.png';
import burgundywhite3 from '@assets/collection/collection/thmartins/burgundywhite3.png';
import burgundywhite4 from '@assets/collection/collection/thmartins/burgundywhite4.png';
import burgundywhite5 from '@assets/collection/collection/thmartins/burgundywhite5.png';
import burgundywhite6 from '@assets/collection/collection/thmartins/burgundywhite6.png';
import burgundywhite7 from '@assets/collection/collection/thmartins/burgundywhite7.png';
import burgundywhite8 from '@assets/collection/collection/thmartins/burgundywhite8.png';
import burgundywhite9 from '@assets/collection/collection/thmartins/burgundywhite9.png';
import burgundywhite10 from '@assets/collection/collection/thmartins/burgundywhite10.png';

import waiting1 from '@assets/collection/collection/thmartins/waiting1.png';
import waiting2 from '@assets/collection/collection/thmartins/waiting2.png';
import waiting3 from '@assets/collection/collection/thmartins/waiting3.png';
import waiting4 from '@assets/collection/collection/thmartins/waiting4.png';
import waiting5 from '@assets/collection/collection/thmartins/waiting5.png';
import waiting6 from '@assets/collection/collection/thmartins/waiting6.png';
import waiting7 from '@assets/collection/collection/thmartins/waiting7.png';
import waiting8 from '@assets/collection/collection/thmartins/waiting8.png';
import waiting9 from '@assets/collection/collection/thmartins/waiting9.png';
import waiting10 from '@assets/collection/collection/thmartins/waiting10.png';
import waiting11 from '@assets/collection/collection/thmartins/waiting11.png';

import weeksystem1 from '@assets/collection/collection/thmartins/weeksystem1.png';
import weeksystem2 from '@assets/collection/collection/thmartins/weeksystem2.png';
import weeksystem3 from '@assets/collection/collection/thmartins/weeksystem3.png';
import weeksystem4 from '@assets/collection/collection/thmartins/weeksystem4.png';
import weeksystem5 from '@assets/collection/collection/thmartins/weeksystem5.png';
import weeksystem6 from '@assets/collection/collection/thmartins/weeksystem6.png';
import weeksystem7 from '@assets/collection/collection/thmartins/weeksystem7.png';

import atelier1 from '@assets/collection/collection/thmartins/atelier1.png';
import atelier2 from '@assets/collection/collection/thmartins/atelier2.png';
import atelier3 from '@assets/collection/collection/thmartins/atelier3.png';
import atelier4 from '@assets/collection/collection/thmartins/atelier4.png';
import atelier5 from '@assets/collection/collection/thmartins/atelier5.png';
import atelier6 from '@assets/collection/collection/thmartins/atelier6.png';
import atelier7 from '@assets/collection/collection/thmartins/atelier7.png';
import atelier8 from '@assets/collection/collection/thmartins/atelier8.png';
import atelier9 from '@assets/collection/collection/thmartins/atelier9.png';
import atelier10 from '@assets/collection/collection/thmartins/atelier10.png';

import covenantfashion1 from '@assets/collection/collection/thmartins/covenantfashion1.png';
import covenantfashion2 from '@assets/collection/collection/thmartins/covenantfashion2.png';
import covenantfashion3 from '@assets/collection/collection/thmartins/covenantfashion3.png';
import covenantfashion4 from '@assets/collection/collection/thmartins/covenantfashion4.png';
import covenantfashion5 from '@assets/collection/collection/thmartins/covenantfashion5.png';
import covenantfashion6 from '@assets/collection/collection/thmartins/covenantfashion6.png';
import covenantfashion7 from '@assets/collection/collection/thmartins/covenantfashion7.png';
import covenantfashion8 from '@assets/collection/collection/thmartins/covenantfashion8.png';
import covenantfashion9 from '@assets/collection/collection/thmartins/covenantfashion9.png';
import covenantfashion10 from '@assets/collection/collection/thmartins/covenantfashion10.png';
import covenantfashion11 from '@assets/collection/collection/thmartins/covenantfashion11.png';
import covenantfashion12 from '@assets/collection/collection/thmartins/covenantfashion12.png';
import covenantfashion13 from '@assets/collection/collection/thmartins/covenantfashion13.png';
import covenantfashion14 from '@assets/collection/collection/thmartins/covenantfashion14.png';
import covenantfashion15 from '@assets/collection/collection/thmartins/covenantfashion15.png';
import covenantfashion16 from '@assets/collection/collection/thmartins/covenantfashion16.png';
import covenantfashion17 from '@assets/collection/collection/thmartins/covenantfashion17.png';


const investPrice = 10.00;
const investPriceDesign = 100.00;
const investPriceTech = 150.00;

const investFashion = 35.00;
const investFashionTech = 200.00;

const investCollection = 20.00;
const investCollectionTech = 1100.00;

const usernamemedium = '@themartinshouse'

export const CWriting = {
  copyWriting: [
    {
      img: poison,
      smalltitle: 'DIOR / HYPNOTIC POISON - EAU DE PARFUM',
      title1: 'ADDICTED TO POWER.',
      title2: 'I WANT MORE... AND MORE.',
      desc: '<b>Intense for an exceptional woman. Attract the power within you. FELL EMPOWERED.</b><br/> Enter a world of enchantment and mystery with Dior Hypnotic Poison. Crafted by the masterful Annick Menardo, this Oriental Vanilla fragrance captivates from the first whiff. Surrender to the creamy allure of almond and coconut...',
      suggestion: 'Read the story'
    },
    {
      media: '/media/diorsauvage.mp4',
      smalltitle: 'DIOR / SAUVAGE - POUR HOMME',
      title1: 'BE BOLD. BE BRAVE.',
      title2: 'SPREAD THE WILDNESS WITHIN YOU.',
      desc: '<b>Irresistible for confident men. Only open-minders know the good taste of being lush. RE-DESIGN YOURSELF TO BE FREE.</b> The fragrance opens with a fresh burst of bergamot from Calabria, which gives it a bright and citrusy start. This is often accompanied by spicy notes of Sichuan pepper...',
      suggestion: 'Read the story'
    },
    {
      img: jordan22,
      smalltitle: 'NIKE / AIR JORDAN 22 - 2007',
      title1: 'NO REASON TO STOP.',
      title2: 'STAY FOCUS AND RISE UP.',
      desc: '<b>Silent yourself and then become a believer. WELCOME TO YOUR BIGNESS AND INFINITY.</b><br/> Step into the future of basketball with the Air Jordan 22, a masterful blend of cutting-edge technology and iconic heritage. Inspired by the sleek precision of the F-22 Raptor, this shoe is engineered for the elite',
      suggestion: 'Read the story'
    },
    {
      media: '/media/breitling.mp4',
      smalltitle: 'BREITLING FOR BENTLEY / PREMIER MULLINER',
      title1: 'BEYOND EXISTENCE AND TIME',
      title2: 'HE IS. HE IS PERFECTION AND LIGHT.',
      desc: '<b>Classic sophistication. Time is unstoppable. STAY ON TIME</b>. Introducing the Breitling for Bentley Premier Mulliner Edition, where Swiss precision meets British luxury. Inspired by the exquisite Bentley Continental GT Mulliner Convertible, this timepiece is a testament to unparalleled craftsmanship and design...',
      suggestion: 'Read the story'
    },
    {
      img: iphone16,
      smalltitle: 'APPLE / IPHONE 16 PRO',
      title1: 'ELEGANCE ENGAGES THE EXCEPTIONAL.',
      title2: 'CONQUER THE IMPOSSIBLE.',
      desc: "<b>Dominate the WORLD!</b> Raise your photography skills with a state-of-the-art device right at your fingertips! The new Camera Control button is here to make your life easier! This is your go-to tool for effortless management of exposure, depth and vibrancy – it's the perfect choice!",
      suggestion: 'Read the story'
    },
    {
      media: '/media/rollsroyce_spectre.mp4',
      smalltitle: 'ROLLS ROYCE / SPECTRE',
      title1: '…ABOVE WORDS AND BEYOND…',
      title2: 'BE THE UNTHINKABLE. UNTOUCHABLE.',
      desc: "The Rolls-Royce Spectre is here. The world's first drastic-luxury electric vehicle. A masterpiece of engineering and design, the Spectre redefines what it means to drive in elegance. Seamlessly combining our century-old heritage with groundbreaking technology, it offers a whisper-quiet, zero-emission journey.",
      suggestion: 'Read the story'
    },
    {
      img: trust_copy,
      smalltitle: "MARTIN'S",
      title1: "OUR SERVICES DON'T FIT",
      title2: 'YOUR LACK OF TRUST!',
      desc: "We don't chase clients - we attract the right ones.If you don't trust us, our services aren't for you. We don't rely on gimmicks or exaggerated claims. Instead, we let our quality, expertise and proven results speak for themselves. We don't waste time on empty promises. Our services are for those who know what they...",
      suggestion: 'Read the story'
    }
  ],
  uxWriting: [
    {
      img: landingpages,
      smalltitle: 'EMAIL MARKETING',
      title1: 'REMARKABLE AS EXPECTED.',
      title2: 'AND A GOLDEN TOUCH. VERY SUMMERISH.',
      desc: 'Immerse yourself in the captivating charm of a breathtaking neutral black and white runway, radiating an aura of abundance and refinement. This exquisite collection is meticulously crafted to empower and uplift the stylish women who embrace it.',
      suggestion: 'Read the story'
    },
    {
      img: heros,
      smalltitle: 'UX WRITING / HEROS',
      title1: 'ALL HEROS UP!',
      title2: 'AND A GOLDEN TOUCH. VERY SUMMERISH.',
      desc: 'Immerse yourself in the captivating charm of a breathtaking neutral black and white runway, radiating an aura of abundance and refinement. This exquisite collection is meticulously crafted to empower and uplift the stylish women who embrace it.',
      suggestion: 'Read the story'
    },
    {
      img: content,
      smalltitle: 'UX WRITING / CONTENT',
      title1: 'WHITE AND BLACK.',
      title2: 'AND A GOLDEN TOUCH. VERY SUMMERISH.',
      desc: 'Immerse yourself in the captivating charm of a breathtaking neutral black and white runway, radiating an aura of abundance and refinement. This exquisite collection is meticulously crafted to empower and uplift the stylish women who embrace it.',
      suggestion: 'Read the story'
    },
    {
      img: uxwrting,
      smalltitle: 'UX WRITING / ERROR PAGES',
      title1: 'OooPS!.',
      title2: 'THIS PAGE DOES NOT EXIST.',
      desc: 'Immerse yourself in the captivating charm of a breathtaking neutral black and white runway, radiating an aura of abundance and refinement. This exquisite collection is meticulously crafted to empower and uplift the stylish women who embrace it.',
      suggestion: 'Read the story'
    }
  ],
  techWriting: [
    {
      img: api,
      smalltitle: 'TECHNICAL WRITING / API DOCUMENTATION',
      title1: 'UNDERSTANDING APIS.',
      title2: 'FOR SOFTWARE ENGINEERS.',
      desc: 'APIs are a crucial part of modern software development, enabling different systems to interact seamlessly. Whether you are a software engineer building APIs or a non-technical stakeholder managing projects that involve APIs, understanding the fundamental concepts and best practices is essential.',
      suggestion: 'Read the documentation'
    },
    {
      img: python,
      smalltitle: 'TECHNICAL WRITING / NEXT.JS AND PYTHON',
      title1: 'NEXT.JS AND PYTHON.',
      title2: 'FRONT END AND BACK END APPS.',
      desc: 'This document provides a step-by-step guide to building a full-stack web application using Next.js for the frontend and Python (with Flask) for the backend. It is designed for both software engineers and non-technical individuals interested in learning the basics of web development.',
      suggestion: 'Read the documentation'
    },
    {
      img: cybersecurity_AI,
      smalltitle: 'TECHNICAL CONTENT WRITING / CYBERSECURITY',
      title1: 'THE BOOK OF CYBER AI.',
      title2: 'WHERE HUMAN RACE AND TIME STOP.',
      desc: "What is AI? That's an easy question for a complex explanation. Artificial Intelligence (AI) is the simulation of human intelligence in machines designed to think and learn like humans AI encompasses various technologies and techniques to enable machines...",
      suggestion: 'Read the documentation'
    }
  ],
  landing: [
    {
      media: '/media/chanel_FW_25_26_RTW.mp4',
      desc: 'Fashion & Beauty Writing',
      url: '/ads',
      num: 0
    },
    {
      img: techW,
      desc: 'Technical Writing',
      url: '/Techwriting',
      num: 1
    },
    // {
    //   img: abundance,
    //   desc: 'Gospel Writing & Christian Content',
    //   url: '/Gospel',
    //   num: 2
    // },
    {
      img: magazine,
      desc: 'Fass-hion Magazine - Where visionaries meet',
      url: 'https://fass-hion.jorgedd.com',
      num: 2
    },
    {
      img: ebook_ad,
      desc: "Shop Martin's series",
      url: 'https://payhip.com/martinswriters',
      num: 3
    },
    {
      img: magazineW,
      desc: 'Magazine writers',
      url: '/Magazinewriting',
      num: 4
    },
    // {
    //   img: akchanel,
    //   desc: 'AI-Enhanced Fashion & Creative Writing',
    //   url: '/stylists',
    //   num: 5
    // },
    {
      img: vision,
      desc: 'Business Coaching program',
      url: '/coaching/program/',
      num: 5
    },
    {
      img: women40_blog,
      url: `https://medium.com/${usernamemedium}/the-evolution-of-evening-wear-bold-elegance-in-white-and-red-wine-46aa9f3ddd81`,
      num: 6
    },
    {
      img: yourstory_blog,
      url: '/blog/your_story_our_words_the_art_of_fashion_writing/',
      num: 7
    },
    {
      img: blackwhite,
      url: '/blog/the_delightful_balck_and_white/',
      num: 8
    },
    {
      img: summertips,
      url: '/blog/how_to_dress_well_for_your_evenings_this_summer/',
      num: 9
    },
    {
      img: ai_not_creative,
      url: '/blog/ai-is-not-creative-the-human-race-is-will-ai-replace-humans-in-the-future/',
      num: 10
    },
    {
      img: your_story,
      url: '/blog/the_tale_of_your_soul_has_been_written_but_you_are_not_aware/',
      num: 11
    },
    {
      img: luxurymag,
      url: '/blog/the_intersection_of_elegance_and_luxury/',
      num: 12
    },
    {
      img: gemstonesblog,
      url: '/blog/women_in_high_fashion_are_gemstones_in_every_colour/',
      num: 13
    },
    {
      img: watch,
      url: '/blog/the_heavenly_touch_of_glorious_gold/',
      num: 14
    },
    {
      img: ageless,
      url: '/blog/at_a_certain_age_life_is_surprisingly_good_when_you_choose_the_right_fashion_outfit_for_yourself/',
      num: 15
    },
    {
      img: collection,
      url: '/collection/black_white/collection_black_white/',
      num: 16
    },
    {
      img: ads,
      url: 'https://www.moringa-magic.com/?hopId=dba9c440-4583-4659-b5b6-34e06ad5db48',
      num: 17
    },
    {
      img: symphony,
      url: `https://medium.com/${usernamemedium}/a-symphony-of-words-feeds-a-soul-80059d181935`,
      num: 18
    },
    {
      img: shape,
      url: '/collection/black_white/collection_black_white/',
      num: 19
    },
    {
      img: lips,
      url: `https://medium.com/${usernamemedium}/five-premium-lipstick-colours-for-your-night-outs-youll-adore-6fa954df9674`,
      num: 20
    },
    {
      img: over40,
      url: `https://medium.com/${usernamemedium}/dress-to-impress-c5bc9cb9c3ab`,
      num: 21
    },
    {
      img: scandal,
      url: `https://medium.com/${usernamemedium}/ai-scandal-whos-behind-it-851c7560846a`,
      num: 22
    },
    {
      img: eyes,
      url: `https://medium.com/${usernamemedium}/eye-makeup-trends-that-celebs-are-wearing-will-blow-your-mind-926fe7d843d5`,
      num: 23
    },
    {
      img: bold,
      url: `https://medium.com/${usernamemedium}/be-fashionably-bold-and-redefining-identity-in-the-fall-winter-25-26-collection-1f74c26421a5`,
      num: 24
    },
    {
      img: box,
      url: `https://medium.com/${usernamemedium}/build-your-tone-think-out-of-the-box-1aeb2d50a716`,
      num: 25
    },
    {
      img: elegance,
      url: `https://medium.com/${usernamemedium}/elegance-is-a-decision-the-bold-truth-about-dressing-well-d81d49ee7cfb`,
      num: 26
    },
    {
      img: goldensea,
      url: `https://medium.com/${usernamemedium}/a-tale-of-high-fashion-bathed-in-white-and-gold-303e3477937d`,
      num: 27
    },
    {
      img: nowords,
      url: `https://medium.com/${usernamemedium}/the-art-of-no-words-when-fashion-and-lifestyle-speak-for-themselves-cc56eac0d299`,
      num: 28
    },
    {
      img: unlock,
      url: `https://medium.com/${usernamemedium}/unlock-the-secret-to-timeless-style-at-any-age-5260a934569a`,
      num: 29
    },
    {
      img: diamond,
      url: `https://medium.com/${usernamemedium}/there-are-diamonds-and-then-theres-you-f6714b222e11`,
      num: 30
    },
    {
      img: sophistication,
      url: `https://medium.com/${usernamemedium}/a-touch-of-splendour-and-sophistication-e9aed8aa63f6`,
      num: 31
    },
    {
      img: white,
      url: `https://medium.com/${usernamemedium}/the-purity-and-excellence-of-white-dress-smartly-and-clearly-aedfb79f13d8`,
      num: 32
    },
    {
      img: whitegold,
      url: `https://medium.com/${usernamemedium}/just-think-whats-the-one-thing-that-makes-you-stand-out-from-everyone-else-fd0727fb50c2`,
      num: 33
    },
    {
      img: cosmetics,
      url: `https://medium.com/${usernamemedium}/how-can-you-become-confident-with-these-three-astonishing-steps-in-your-30s-40s-and-50s-fa42fcbeaa68`,
      num: 34
    },
    {
      img: business,
      url: `https://medium.com/${usernamemedium}/i-froze-when-i-heard-that-these-ai-apps-are-redefining-entrepreneurial-greatness-aa310a940ea2`,
      num: 35
    },
    {
      img: business_owner,
      url: `https://medium.com/${usernamemedium}/unlock-the-secrets-to-dressing-like-a-business-owner-essential-recommendations-for-your-success-9eb2b5513fea`,
      num: 36
    },
    {
      img: red,
      url: `https://medium.com/${usernamemedium}/the-philosophy-of-red-in-the-business-world-fd26e47fd53c`,
      num: 37
    },
    {
      img: blue,
      url: `https://medium.com/${usernamemedium}/in-the-entrepreneurs-world-blue-is-the-shape-of-belief-0b5f2cac1893`,
      num: 38
    },
    {
      img: isaiah,
      url: `https://medium.com/${usernamemedium}/a-divine-promise-of-strength-courage-and-support-30f68d0ba862`,
      num: 39
    },
    {
      img: idea,
      url: `https://medium.com/${usernamemedium}/when-god-gives-you-a-business-idea-purpose-management-and-style-guided-by-divine-wisdom-83fc69638f35`,
      num: 40
    },
    {
      img: life,
      url: `https://medium.com/${usernamemedium}/life-is-the-melody-of-jesus-7795d5402d2a`,
      num: 41
    },
    {
      img: jesus,
      url: `https://medium.com/${usernamemedium}/the-guardian-of-my-soul-46f65d174b25`,
      num: 42
    },
    {
      img: lady_red,
      url: `https://medium.com/${usernamemedium}/the-most-visionary-businesswomen-are-modern-and-passionate-their-vision-is-a-focus-ae8989ffe9f1`,
      num: 43
    },
    {
      img: bible,
      url: `https://medium.com/${usernamemedium}/jesus-is-god-almighty-biblical-evidence-and-theological-insights-54ee8327207d`,
      num: 44
    },
    {
      img: lady_martins,
      url: 'https://medium.com/@themartinshouse/the-reflection-of-fashion-in-the-business-arena-a-dynamic-businesswomans-style-and-mindset-f02cca4a603d',
      num: 45
    },
    {
      img: stone,
      url: 'https://medium.com/@themartinshouse/the-power-of-patience-understanding-habakkuk-2-3-and-trusting-gods-timing-e47c579663b6',
      num: 46
    },
    {
      img: rebecca,
      url: 'https://medium.com/@themartinshouse/rebecca-pagani-the-rising-star-of-european-editorial-elegance-ab021550e5bc',
      num: 47
    },
    {
      img: leather,
      url: 'https://medium.com/@themartinshouse/summer-2025-has-arrived-what-should-you-wear-this-season-eb5b97672775',
      num: 48
    },
    {
      img: alexandra,
      url: 'https://medium.com/@themartinshouse/the-hottest-and-most-irresistible-fabrics-for-ladies-leather-reigns-supreme-8d28b1603325',
      num: 49
    },
    {
      img: crystal,
      url: 'https://medium.com/@themartinshouse/command-the-night-blend-blue-and-gold-with-a-long-crystal-scarf-for-hot-summer-evenings-ede6368b160d',
      num: 50
    },
    {
      img: dolphin,
      url: 'https://medium.com/@themartinshouse/jesus-is-coming-back-the-signs-are-clear-the-time-is-near-231f5e735e50',
      num: 51
    },
    {
      img: abundance,
      url: 'https://medium.com/@themartinshouse/abundance-is-for-those-who-believe-what-you-think-youll-become-29056d01120a',
      num: 52
    },
    {
      img: chanel5,
      url: 'https://medium.com/@themartinshouse/perfumes-embody-the-essence-of-freedom-they-make-you-feel-sensational-f240681e9c44',
      num: 53
    },
    {
      img: konova,
      url: 'https://medium.com/@themartinshouse/alexandra-konova-the-russian-beauty-who-redefined-elegance-4afe03a31d84',
      num: 54
    },
    {
      img: redwhite,
      url: 'https://medium.com/@themartinshouse/uncover-the-meaning-of-red-and-white-when-you-wear-them-7c9017e1e5e3',
      num: 55
    },
    {
      img: love,
      url: 'https://medium.com/@themartinshouse/faith-hope-and-love-the-eternal-treasures-in-christ-jesus-d145ab018610',
      num: 56
    },
    {
      img: makeup,
      url: 'https://medium.com/@themartinshouse/unveiling-the-future-of-beauty-and-trends-get-ready-for-an-exhilarating-journey-65d0f34fb834',
      num: 57
    },
    {
      img: akchanel,
      url: 'https://medium.com/@themartinshouse/lifeblood-of-magnificence-alexandra-konova-and-the-legacy-of-chanel-5-333cd7120ed0',
      num: 58
    },
    {
      img: dior,
      url: 'https://medium.com/@themartinshouse/dior-the-reinvention-of-haute-couture-and-the-women-who-master-the-art-of-charm-and-grace-0e14261d0926',
      num: 59
    },
    {
      img: wines,
      url: 'https://medium.com/@themartinshouse/wines-and-evening-wear-the-epitome-of-luxury-and-sensuality-dd95e6685cc7',
      num: 60
    },
    {
      img: ask,
      url: 'https://medium.com/@themartinshouse/whatever-you-ask-for-in-prayer-understanding-mark-11-24-the-will-of-christ-the-light-of-life-7e1577c6717e',
      num: 61
    },
    {
      img: mask,
      url: 'https://medium.com/@themartinshouse/wearing-masks-at-evening-events-is-not-a-reflection-of-you-its-a-mystery-810605173519',
      num: 62
    },
    {
      img: jewe,
      url: 'https://medium.com/@themartinshouse/jewellery-the-precious-golden-mind-of-a-lady-5d6dd4aded00',
      num: 63
    },
    {
      img: game,
      url: 'https://medium.com/@themartinshouse/she-builds-with-fire-the-rise-of-the-kingdom-woman-in-business-and-beauty-is-a-game-changer-e7205962a750',
      num: 64
    },
    {
      img: growth,
      url: 'https://medium.com/@themartinshouse/crowned-with-gold-the-unshakable-legacy-of-the-spirit-led-businesswoman-57081fc2eb7e',
      num: 65
    },
    {
      img: possible,
      url: 'https://medium.com/@themartinshouse/with-god-all-things-are-possible-surrendering-fully-to-divine-possibility-a59d04fb5517',
      num: 66
    },
    {
      img: tango,
      url: 'https://medium.com/@themartinshouse/lets-dance-tango-is-the-ultimate-high-fashion-expression-for-businesswomen-c3c54c35cf6f',
      num: 67
    },
    {
      img: eye,
      url: 'https://medium.com/@themartinshouse/the-eye-of-luxury-what-the-spirit-is-saying-to-designers-and-visionaries-1a78d6590d29',
      num: 68
    },
    {
      img: sighs,
      url: 'https://medium.com/@themartinshouse/the-seven-signs-diamonds-are-your-wake-up-call-how-focused-women-build-legacy-d7c4e7a093db',
      num: 69
    },
    {
      img: style,
      url: 'https://medium.com/@themartinshouse/style-is-what-they-see-but-elegance-elegance-is-what-they-feel-c5a1067c289d',
      num: 70
    },
    {
      img: rapture,
      url: 'https://medium.com/@themartinshouse/the-end-of-times-is-near-and-the-rapture-is-now-e1ed2ab78f69',
      num: 71
    },
    {
      img: coffee,
      url: 'https://medium.com/@themartinshouse/coffee-confirmation-the-call-morning-signs-for-the-woman-building-legacy-9a6496cb21ad',
      num: 72
    },
    {
      img: business_m,
      url: 'https://medium.com/@themartinshouse/the-brand-you-didnt-make-up-0f0109d39546',
      num: 73
    },
    {
      img: closet,
      url: 'https://medium.com/@themartinshouse/the-closet-is-a-calling-building-a-wardrobe-for-the-woman-youre-becoming-5a711274b5e4',
      num: 74
    },
    {
      img: psalm30_5,
      url: 'https://medium.com/@themartinshouse/rejoicing-comes-in-the-morning-the-sacred-rhythm-of-psalm-30-5-7d4bc012c7b7',
      num: 75
    },
    {
      img: power,
      url: 'https://medium.com/@themartinshouse/how-she-builds-a-day-rituals-of-power-for-the-fashionable-woman-145862709eee',
      num: 76
    },
    {
      img: sevendays,
      url: 'https://medium.com/@themartinshouse/7-days-to-build-when-heaven-gives-you-the-blueprint-in-pieces-2cba031c5550',
      num: 77
    },
    {
      img: strategy,
      url: 'https://medium.com/@themartinshouse/the-7000-when-god-calls-you-out-of-the-crowd-to-build-what-has-never-been-seen-5d1a45e23a57',
      num: 78
    },
    {
      img: wakeup,
      url: 'https://medium.com/@themartinshouse/wake-up-dress-up-prophesy-a-morning-routine-for-women-who-dont-give-up-1f86aa3230ac',
      num: 79
    },
    {
      img: thescent,
      url: 'https://medium.com/@themartinshouse/the-scent-of-elegance-how-martins-empowers-women-to-walk-in-divine-fashion-and-purpose-247d41257cee',
      num: 80
    },
    {
      img: clothed,
      url: 'https://medium.com/@themartinshouse/crowned-in-faith-clothed-in-purpose-the-journey-of-the-woman-who-perseveres-f9a88ea8389d',
      num: 81
    },
    {
      img: comingsoon,
      url: 'https://medium.com/@themartinshouse/are-you-ready-a-wake-up-call-for-a-world-asleep-5adc3474f8df',
      num: 82
    },
    {
      img: shelter,
      url: 'https://medium.com/@themartinshouse/the-shelter-of-your-soul-is-not-the-paradise-of-your-lifes-journey-it-s-a-breakthrough-moment-496f88fafaa1',
      num: 83
    },
    {
      img: whisper,
      url: 'https://medium.com/@themartinshouse/martins-legacy-as-a-businesswoman-a-whisper-that-will-transform-your-business-lifestyle-ef34b0eadca3',
      num: 84
    },
    {
      img: overcome,
      url: 'https://medium.com/@themartinshouse/what-has-jesus-overcome-in-your-life-the-kingdom-blueprint-for-peace-and-provision-abcad89c451e',
      num: 85
    },
    {
      img: techfashion,
      url: 'https://medium.com/@themartinshouse/when-technology-meets-fashion-with-martins-you-are-your-self-brand-cab6bfd6184e',
      num: 86
    },
    {
      img: looks,
      url: 'https://medium.com/@themartinshouse/fashioned-in-fire-why-some-looks-can-only-be-worn-after-the-battle-56863c3be7d4',
      num: 87
    },
    {
      img: endtimes,
      url: 'https://medium.com/@themartinshouse/the-gospel-of-john-the-book-of-revelation-and-the-end-prophecy-are-we-living-in-the-final-days-efded2a4d85b',
      num: 88
    },
    {
      img: dress_well,
      url: 'https://medium.com/@themartinshouse/dress-well-for-a-glorious-week-the-perfect-outfit-for-a-meeting-c8ed7a9971e5',
      num: 89
    },
    {
      img: waiting,
      url: 'https://medium.com/@themartinshouse/from-waiting-to-new-beginnings-the-journey-you-dont-expect-7cb9b3c783bb',
      num: 90
    },
    {
      img: incase,
      url: 'https://medium.com/@themartinshouse/in-case-you-didnt-know-for-businesswomen-after-40-age-is-just-a-number-775bcf40a15d',
      num: 91
    },
    {
      img: theway,
      url: 'https://medium.com/@themartinshouse/jesus-is-an-awesome-god-hes-the-way-the-truth-and-the-life-b0c3a5b83c32',
      num: 92
    },
    {
      img: stage,
      url: 'https://medium.com/@themartinshouse/the-mansion-as-a-stage-when-dressing-well-is-not-enough-df3f16f12c33',
      num: 93
    },
    {
      img: timeup,
      url: 'https://medium.com/@themartinshouse/times-up-the-overnight-breakthrough-and-the-outfit-that-makes-you-stand-out-674daa510156',
      num: 94
    },
    {
      img: blackandwhite,
      url: 'https://medium.com/@themartinshouse/black-and-white-exude-authority-sophistication-and-boldness-what-to-wear-to-attract-the-right-c2ece09e6d50',
      num: 95
    },
    {
      img: eternal,
      url: 'https://medium.com/@themartinshouse/if-you-dress-in-yellow-youll-become-glorious-and-joyful-why-is-this-colour-the-ultimate-34ae76afb32f',
      num: 96
    },
    {
      img: privatejet,
      url: 'https://medium.com/@themartinshouse/the-private-jet-is-your-business-card-for-greatness-11e32c71885f',
      num: 97
    },
    {
      img: miami,
      url: 'https://medium.com/@themartinshouse/how-to-make-your-business-stand-out-in-a-luxury-hotel-miami-could-be-the-place-for-you-65afbab29a9a',
      num: 98
    },
    {
      img: empire,
      url: 'https://payhip.com/martinswriters/blog/storyteling/giving-up-on-a-million-dollar-empire-you-dreamed-of-is-a-failure',
      num: 99
    },
    {
      img: manager,
      url: 'https://payhip.com/martinswriters/blog/storyteling/from-business-manager-to-businesswoman-ceo-the-road-ahead-of-you',
      num: 100
    },
    {
      img: milliondollar,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-500-million-dollar-businesswoman',
      num: 101
    },
    {
      img: ceo,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-ceo-s-ascent-building-vision-into-reality',
      num: 102
    },
    {
      img: tweed,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-visionary-woman-legacy-beyond-the-boardroom',
      num: 103
    },
    {
      img: movement,
      url: 'https://payhip.com/martinswriters/blog/storyteling/martin-s-is-not-a-business-it-s-a-movement-for-businesswomen',
      num: 104
    },
    {
      img: wardrobe_tweed,
      url: 'https://payhip.com/martinswriters/blog/storyteling/guess-what-tweed-is-the-king-of-your-wardrobe',
      num: 105
    },
    {
      img: silk,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-call-of-boldness-for-business-managers-your-time-s-now',
      num: 106
    },
    {
      img: jeans,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-art-of-becoming-a-masterpiece-why-every-businesswoman-must-retreat-before-she-rises',
      num: 107
    },
    {
      img: watch_mt,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-watch-and-the-woman-when-time-becomes-her-throne',
      num: 108
    },
    {
      img: everything,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-truth-about-everything-no-one-can-stop-you',
      num: 109
    },
    {
      img: final,
      url: 'https://payhip.com/martinswriters/blog/storyteling/this-is-the-final-touch-you-need-before-you-re-ready',
      num: 110
    },
    {
      img: reason,
      url: 'https://payhip.com/martinswriters/blog/storyteling/you-are-the-reason-when-vision-becomes-the-foundation-of-creation',
      num: 111
    },
    {
      img: brand,
      url: 'https://payhip.com/martinswriters/blog/storyteling/helen-quinn-the-visionary-behind-a-brand',
      num: 112
    },
    {
      img: signature,
      url: 'https://payhip.com/martinswriters/blog/storyteling/for-women-your-signature-is-gold-and-builds-momentum',
      num: 113
    },
    {
      img: despite,
      url: 'https://payhip.com/martinswriters/blog/storyteling/despite-the-struggles-i-decided-to-build-my-business',
      num: 114
    },
    {
      img: society,
      url: 'https://payhip.com/martinswriters/blog/storyteling/fashion-drop-the-secret-society-of-women-who-move-in-silence-and-style',
      num: 115
    },
    {
      img: sell,
      url: 'https://payhip.com/martinswriters/blog/storyteling/what-does-martin-s-sell-we-sell-legacy-identity-and-transformation',
      num: 116
    },
    {
      img: zone,
      url: 'https://payhip.com/martinswriters/blog/storyteling/your-uncomfortable-zone-is-the-place-to-be-how-a-ceo-on-the-red-carpet-redefines-power',
      num: 117
    },
    {
      img: story,
      url: 'https://payhip.com/martinswriters/blog/storyteling/your-story-is-written-everywhere-the-beatrice-mclaren-empire',
      num: 118
    },
    {
      img: mentor,
      url: 'https://payhip.com/martinswriters/blog/storyteling/someone-s-story-is-in-your-hands-you-are-a-storyteller-inside-daniella-steel-s-coaching-revolution',
      num: 119
    },
    {
      img: vision,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-art-of-alignment-how-to-create-a-business-that-fits-your-vision',
      num: 120
    },
    {
      img: coaching,
      url: 'https://payhip.com/martinswriters/blog/storyteling/this-business-coaching-programme-has-changed-my-life-how-celine-marta-became-the-visionary',
      num: 121
    },
    {
      img: expensive,
      url: 'https://payhip.com/martinswriters/blog/storyteling/before-you-are-look-like-who-you-will-be-the-art-of-looking-expensive-as-a-businesswoman',
      num: 122
    },
    {
      img: sevensigns,
      url: 'https://payhip.com/martinswriters/blog/storyteling/7-signs-you-re-on-the-right-path-to-becoming-a-successful-businesswoman',
      num: 123
    },
    {
      img: colours,
      url: 'https://payhip.com/martinswriters/blog/storyteling/dress-like-power-the-most-expensive-colour-combinations-for-female-ceos',
      num: 124
    },
    {
      img: sit,
      url: 'https://payhip.com/martinswriters/blog/storyteling/how-to-sit-like-a-ceo-posture-and-manners-for-sophisticated-businesswomen',
      num: 125
    },
    {
      img: breakthrough,
      url: 'https://payhip.com/martinswriters/blog/storyteling/elle-brooke-the-breakthrough-arrived-and-i-didn-t-notice',
      num: 126
    },
    {
      img: job,
      url: 'https://payhip.com/martinswriters/blog/storyteling/i-was-dragged-out-of-a-9-5-job-to-build-my-business',
      num: 127
    },
    {
      img: wealth,
      url: 'https://payhip.com/martinswriters/blog/storyteling/your-signature-sets-you-apart-it-s-wealth-abundance-and-female-intuition',
      num: 128
    },
    {
      img: ceoSignature,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-ceo-signature-collection-by-martin-s',
      num: 129
    },
    {
      img: gossip,
      url: 'https://payhip.com/martinswriters/blog/storyteling/for-businesswomen-gossip-will-kill-your-vision-and-sophistication',
      num: 130
    },
    {
      img: highheels,
      url: 'https://payhip.com/martinswriters/blog/storyteling/high-heels-high-calling-the-hidden-authority-of-a-businesswoman-of-power',
      num: 131
    },
    {
      img: way,
      url: 'https://payhip.com/martinswriters/blog/storyteling/a-god-s-business-way-it-s-not-your-way-or-about-you',
      num: 132
    },
    {
      img: vera,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-best-turnaround-of-my-life-the-rise-of-v-l-vera-from-chit-chat-writer-to-god-led-businesswoman',
      num: 133
    },
    {
      img: plan,
      url: 'https://payhip.com/martinswriters/blog/storyteling/do-you-really-need-a-strategic-plan-to-run-your-business-dr-leila-watson-has-a-surprising-answer',
      num: 134
    },
    {
      img: premium_power,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-mystery-about-lingerie-why-do-premium-businesswomen-wear-power',
      num: 135
    },
    {
      img: second,
      url: 'https://payhip.com/martinswriters/blog/storyteling/why-a-dead-business-will-never-deserve-your-seconds-and-why-a-luxury-watch-belongs-on-the-wrist-of-every-businesswoman',
      num: 136
    },
    {
      img: jumpsuit,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-power-of-one-how-the-evening-jumpsuit-defines-modern-businesswoman-elegance',
      num: 137
    },
    {
      img: babyborn,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-ceo-who-chooses-life-why-every-woman-in-leadership-must-become-a-voice-for-the-unborn',
      num: 138
    },
    {
      img: legacy,
      url: 'https://payhip.com/martinswriters/blog/storyteling/who-is-she-from-destruction-to-legacy-the-unapologetic-story-of-margaret-steves',
      num: 139
    },
    {
      img: everyCEO,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-collection-every-ceo-is-talking-about-ceo-signature-by-martin-s-is-a-businesswoman-s-splendour',
      num: 140
    },
    {
      img: imposter,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-silent-saboteur-how-impostor-syndrome-threatens-the-female-ceo-s-mission',
      num: 141
    },
    {
      img: world_ceo,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-creative-ceo-why-confidence-is-the-real-capital-of-innovation',
      num: 142
    },
    {
      img: rebuilding,
      url: 'https://payhip.com/martinswriters/blog/storyteling/rebuilding-the-woman-behind-the-brand-inside-martin-s-identity-work-for-ceos',
      num: 143
    },
    {
      img: jewish,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-torah-of-talent-how-wisdom-traditions-empower-modern-jewish-women-leaders',
      num: 144
    },
    {
      img: presents,
      url: 'https://payhip.com/martinswriters/blog/storyteling/martin-s-house-presents-the-ceo-signature-businesswear-full-year-2026',
      num: 145
    },
    {
      img: martinshouse,
      url: 'https://payhip.com/martinswriters/blog/storyteling/martin-s-house-dresses-and-rewrites-the-global-woman-ceo-without-erasing-her-culture-beliefs-or-identity',
      num: 146
    },
    {
      img: martins_christmas,
      url: 'https://payhip.com/martinswriters/blog/storyteling/a-christmas-kit-for-female-ceos-why-the-most-powerful-gift-you-can-give-your-clients-is-not-an-object-but-your-identity',
      num: 147
    },
    {
      img: asian,
      url: 'https://payhip.com/martinswriters/blog/storyteling/reserved-but-radiant-how-asian-women-ceos-lead-with-discipline-depth-and-distinction',
      num: 148
    },
    {
      img: threesignature,
      url: 'https://payhip.com/martinswriters/blog/storyteling/empowering-you-three-signature-designs-for-ceos-to-triumph-over-impostor-syndrome',
      num: 149
    },
    {
      img: strong,
      url: 'https://payhip.com/martinswriters/blog/storyteling/strong-and-successful-women-are-not-born-they-are-shaped-by-the-storms-they-walk-through',
      num: 150
    },
    {
      img: bestyear,
      url: 'https://payhip.com/martinswriters/blog/storyteling/the-best-year-is-yet-to-come-why-2026-will-fulfil-the-dreams-of-women-ceos',
      num: 151
    },
    {
      img: nextchaper,
      url: 'https://payhip.com/@themartinshouse/blog/storyteling/your-next-chapter-is-titled-wealthy-blessed-the-rise-of-women-ceos',
      num: 152
    },
    {
      img: yourmask,
      url: 'https://medium.com/@themartinshouse/your-mask-is-your-protection-inside-the-silent-architecture-of-female-ceos-ebe7d22e8e3b',
      num: 153
    },
    {
      img: blackceo,
      url: 'https://medium.com/@themartinshouse/black-diamonds-how-black-women-ceos-are-redefining-power-in-the-world-of-entrepreneurship-aaf2bfb1f544',
      num: 154
    },
    {
      img: celebrateyourself,
      url: 'https://medium.com/@themartinshouse/the-best-version-of-yourself-will-celebrate-you-at-the-right-time-6b116a3bfe19',
      num: 155
    },
    {
      img: agony,
      url: 'https://medium.com/@themartinshouse/if-your-path-demands-that-you-go-through-agony-walk-like-you-own-the-place-2aa29e612561',
      num: 156
    },
    {
      img: bounce_back,
      url: `https://medium.com/${usernamemedium}/strong-women-ceos-never-give-up-they-always-bounce-back-78a8c98f29cc`,
      num: 157
    },
    {
      img: leadership,
      url: `https://medium.com/${usernamemedium}/the-language-of-leadership-how-women-ceos-speak-with-authority-0e89da0884aa`,
      num: 158
    },
    {
      img: brandauthor,
      url: `https://medium.com/${usernamemedium}/the-woman-behind-the-brand-is-the-author-of-its-power-ff63da267c4c`,
      num: 159
    },
    {
      img: shapeculture,
      url: `https://medium.com/${usernamemedium}/when-leadership-becomes-editorial-how-women-unapologetically-shape-culture-c63452133803`,
      num: 160
    },
    {
      img: mondays,
      url: `https://medium.com/${usernamemedium}/ceo-signature-businesswear-tips-why-the-most-powerful-businesswomen-rarely-explain-themselves-c0e9f130b64b`,
      num: 161
    },
    {
      img: wardrobe,
      url: `https://medium.com/${usernamemedium}/the-wardrobe-of-a-serious-writer-how-presence-shapes-perception-9a7c1dc683f2`,
      num: 162
    },
    {
      img: womenlife,
      url: `https://medium.com/${usernamemedium}/how-far-would-you-go-to-get-your-business-life-back-on-track-865a7cc4ff91`,
      num: 163
    },
    {
      img: command,
      url: `https://medium.com/${usernamemedium}/elegance-is-a-form-of-command-the-discipline-of-women-who-run-the-room-874156fe442d`,
      num: 164
    },
    {
      img: wears_magazine,
      url: `https://medium.com/${usernamemedium}/dressed-like-a-decision-why-what-a-woman-ceo-wears-is-never-accidental-d96c58866b84`,
      num: 165
    },
    {
      img: week1_magazine,
      url: `https://medium.com/${usernamemedium}/body-language-series-week-i-silent-authority-the-body-speaks-before-you-do-fb289ec76054`,
      num: 166
    },
    {
      img: inside_magazine,
      url: `https://medium.com/${usernamemedium}/the-woman-behind-the-brand-needs-coaching-too-rewriting-leadership-from-the-inside-a3d3edbdc31f?postPublishedType=initial`,
      num: 167
    },
    {
      img: investors_magazine,
      url: 'https://medium.com/p/799caff0df72?postPublishedType=initial',
      num: 168
    },
    {
      img: notblocked_magazine,
      url: 'https://medium.com/p/a718a1314cba?postPublishedType=initial',
      num: 169
    },
    {
      img: purpose_magazine,
      url: 'https://medium.com/p/184d7b4cf33e?postPublishedType=initial',
      num: 170
    },
    {
      img: decode_magazine,
      url: 'https://medium.com/p/ab7f1e184b95?postPublishedType=initial',
      num: 171
    },
    {
      img: likethem_magazine,
      url: 'https://medium.com/p/445854699e5b?postPublishedType=initial',
      num: 172
    },
    {
      img: negotiation_magazine,
      url: 'https://medium.com/p/01a68bea667c?postPublishedType=initial',
      num: 173
    },
    {
      img: draft_magazine,
      url: `https://medium.com/${usernamemedium}/your-draft-is-not-the-problem-your-positioning-is-e548035770ab`,
      num: 174
    },
    {
      img: shoesheels_magazine,
      url: `https://medium.com/${usernamemedium}/the-shoe-strategy-heels-sneakers-and-power-transitions-20172bb062c5`,
      num: 175
    },
    {
      img: weekIII_magazine,
      url: `https://medium.com/${usernamemedium}/week-iii-strategic-stillness-how-silence-forces-others-to-show-their-true-colours-403e14689f09`,
      num: 176
    },
    {
      img: boundary_magazine,
      url: `https://medium.com/${usernamemedium}/elegance-is-a-boundary-not-an-aesthetic-f416027ab919`,
      num: 177
    },
    {
      img: attract_magazine,
      url: `https://medium.com/${usernamemedium}/book-1-the-interview-with-myself-i-dont-chase-i-attract-21a17a31a134`,
      num: 178
    },
    {
      img: jeansdemin_magazine,
      url: `https://medium.com/${usernamemedium}/jeans-denim-why-powerful-women-dont-dress-for-visibility-3b9e54871221`,
      num: 179
    },
    {
      img: positions_magazine,
      url: `https://medium.com/${usernamemedium}/week-iv-pressure-positions-how-to-maintain-authority-when-everyone-is-watching-9c6d56079d56`,
      num: 180
    },
    {
      img: dontfail_magazine,
      url: `https://medium.com/${usernamemedium}/brands-dont-fail-their-founders-get-noisy-be65a4a5a9a6`,
      num: 181
    },
    {
      img: architecture_magazine,
      url: `https://medium.com/${usernamemedium}/book-2-the-interview-with-myself-the-architecture-of-authority-a6bc010d94f9`,
      num: 182
    },
    {
      img: readingroom_magazine,
      url: `https://medium.com/${usernamemedium}/week-v-reading-the-room-before-it-speaks-strategic-perception-for-women-leaders-8d00a413449c`,
      num: 183
    },
    {
      img: strongbrands_magazine,
      url: `https://medium.com/${usernamemedium}/the-discipline-of-simplicity-why-strong-brands-eliminate-before-they-expand-3fe592fc0180`,
      num: 184
    },
    {
      img: institution_magazine,
      url: `https://medium.com/${usernamemedium}/book-3-the-interview-with-myself-the-house-becomes-an-institution-2aa0b2bbb2f7`,
      num: 185
    },
    {
      img: HighFashion_magazine,
      url: `https://medium.com/${usernamemedium}/silhouette-as-leverage-a-letter-on-capital-culture-high-fashion-and-the-architecture-of-9490703c41c8`,
      num: 186
    },
    {
      img: victory_magazine,
      url: `https://medium.com/${usernamemedium}/victory-the-card-before-the-conversation-c5383a7c68dd`,
      num: 187
    },
    {
      img: pinkcard_magazine,
      url: `https://medium.com/${usernamemedium}/black-white-gold-and-pink-the-four-colours-of-executive-authority-413a3d84c7fe`,
      num: 188
    },
    {
      img: survival_magazine,
      url: `https://medium.com/${usernamemedium}/from-survival-mode-to-signature-leadership-c25f20ccdc66`,
      num: 189
    },
    {
      img: attraction_magazine,
      url: `https://medium.com/${usernamemedium}/the-attraction-of-your-business-card-is-a-sign-6ca9a892990e`,
      num: 190
    },
    {
      img: squareclassic_magazine,
      url: `https://medium.com/${usernamemedium}/square-or-classic-the-geometry-of-power-03eefc4df70f`,
      num: 191
    },
    {
      img: identity_magazine,
      url: `https://medium.com/${usernamemedium}/victory-executive-luxury-the-first-editorial-story-a-rule-that-governs-identity-52e83d8d8e7f`,
      num: 192
    },
    {
      img: lost_magazine,
      url: `https://medium.com/${usernamemedium}/you-are-not-lost-you-are-between-identities-c62a4173a3d9`,
      num: 193
    },
    {
      img: beginning_magazine,
      url: `https://medium.com/${usernamemedium}/victory-executive-luxury-is-not-a-card-its-a-beginning-535d91479bab`,
      title: "Victory - Executive Luxury Is Not a Card, It's a Beginning.",
      num: 194
    },
    {
      img: beyond_magazine,
      url: '/stories/Beyond_Fashion_and_Branding/',
      title: 'Beyond Fashion and Branding -  Welcome to Victory-Executive Luxury Haute Couture.',
      num: 195
    },
    {
      img: whatchanges_magazine,
      url: '/stories/What_Changes/',
      title: 'What Changes When You Stop Explaining Yourself?',
      num: 196
    },
    {
      img: changetime_magazine,
      url: '/stories/The_Story_That_Changed_Everything/',
      title: 'The Story That Changed Everything - Including Me.',
      num: 197
    },
    {
      img: wherfaith_magazine,
      url: '/stories/Where_Faith_Meets_Executive_Power/',
      title: 'The Covenant Collection - Where Faith Meets Executive Power.',
      num: 198
    },
    {
      img: behindpower_magazine,
      url: '/stories/Designing_the_Presence_Behind_Power/',
      title: 'Victory-Executive Luxury: Designing the Presence Behind Power.',
      num: 199
    },
    {
      img: everythingyou_magazine,
      url: '/stories/Everything_You_Should_Know/',
      title: "Everything You Should Know About Martin's House.",
      num: 200
    },
    {
      img: dontchace_magazine,
      url: '/stories/Dont_Chase_Clients/',
      title: "Don't Chase Clients & Partnerships - Attract Them.",
      num: 201
    },
    {
      img: havevision_magazine,
      url: '/stories/You_Have_the_Vision_We_Design_the_Presence/',
      title: 'You Have the Vision - We Design the Presence.',
      num: 202
    },
    {
      img: yoursuccess_magazine,
      url: '/stories/Your_Success_Is_For_a_Reason/',
      title: "Your Success Is For a Reason - It's Aligned with the Path Yeshua Has Set for You.",
      num: 203
    },
    {
      img: noteveryone_magazine,
      url: '/stories/Not_Everyone_Needs/',
      title: "Not Everyone Needs Martin's House - Only Those Who Are Ready.",
      num: 204
    },
    {
      img: youarepowerful_magazine,
      url: '/stories/You_Are_Already_Powerful/',
      title: 'You Are Already Powerful - We Make It Unmistakable.',
      num: 205
    },
    {
      img: Cover_Cards_Magazine_Launch_magazine,
      url: '/stories/Presence_Cards/',
      title: 'Identity, and presence Cards Magazine Launch.',
      num: 206
    },
    {
      img: The_Song_magazine,
      url: '/stories/The_Song/',
      title: 'The Song You Never Heard Before: The Sound of Your Intuition.',
      num: 207
    },
    {
      img: From_success_Sense_magazine,
      url: '/stories/From_Success_to_Sense/',
      title: 'From Success to Sense: The House Where It Happens.',
      num: 208
    },
    {
      img: Where_Leadership_magazine,
      url: '/stories/Where_Leadership/',
      title: 'Victory - Executive Luxury: Where Leadership Turns Into Legacy.',
      num: 209
    },
    {
      img: Strength_and_Elegance_magazine,
      url: '/stories/Strength_and_Elegance/',
      title: 'Strength and Elegance Are Written in the Same Pact.',
      num: 210
    },
    {
      img: Corporate_Authority_magazine,
      url: '/stories/Corporate_Authority/',
      title: 'Executive Luxury Is the New Corporate Authority.',
      num: 211
    },
    {
      img: Best_Women_magazine,
      url: '/stories/Best_Women/',
      title: "Book I: The Best Women CEOs' Stories - Get Inspired.",
      num: 212
    },
    {
      img: Signature_Series_magazine,
      url: '/stories/Signature_Series/',
      title: "The Signature Series - A Private Identity System by Martin's House.",
      num: 213
    },
    {
      img: Your_Signature_magazine,
      url: '/stories/Your_Signature/',
      title: 'Your Signature Is More Than a Name - It Is the Standard You Bring Into Every Room.',
      num: 214
    },
    {
      img: Get_Uncomfortable_magazine,
      url: '/stories/Get_Uncomfortable/',
      title: 'First Business Rule: Comfort Is the Enemy of Growth - Get Uncomfortable!',
      num: 215
    },
    {
      img: The_Business_Psychology_magazine,
      url: '/stories/The_Business_Psychology/',
      title: 'Dressed Like a Leader: The Business Psychology Behind Structured Tailoring.',
      num: 216
    },
    {
      img: Executive_Identity_Wear_magazine,
      url: '/stories/Executive_Identity_Wear/',
      title: "Martin's House Unveils Executive Identity Wear™ for the Modern Woman Leader.",
      num: 217
    },
    {
      img: Executive_denim_magazine,
      url: '/stories/Executive_Denim/',
      title: "Beyond Businesswear: Martin's House Introduces Executive Identity Denim™ for the Modern Woman Leader.",
      num: 218
    },
    {
      img: Alexandra_Victor_magazine,
      url: '/stories/Alexandra_Victor/',
      title: "Martin's House & Alexandra Victor - The Vision and the Woman Who Materialised It.",
      num: 219
    },
    {
      img: The_Best_Perfume_magazine,
      url: '/stories/The_Best_Perfume/',
      title: 'The Best Perfume to Combine With Your Leadership - The Delicious Scent.',
      num: 220
    },
    {
      img: identity_coaching_magazine,
      url: '/stories/Identity_Coaching/',
      title: "Martin's House: The Executive Identity Coaching Programme™.",
      num: 221
    },
    {
      img: The_woman_in_control_magazine,
      url: '/stories/The_Woman_In_Control/',
      title: 'The Mask, the Myth, and the Woman in Control.',
      num: 222
    },
    {
      img: Sophisticated_makeup_magazine,
      url: '/stories/Sophisticated_makeup/',
      title: 'The Executive Face™: How Sophisticated Makeup Shapes Power, Presence and Leadership.',
      num: 223
    },
    {
      img: Elegance_Every_Move_magazine,
      url: '/stories/Elegance_Every_Move/',
      title: 'Power in Every Detail. Elegance in Every Move. DANIELL.',
      num: 224
    },
    {
      img: Cover_Luxury_Identity_Consultancy,
      url: '/stories/Luxury_Identity_Consultancy/',
      title: "Daniell by Martin's House: The Luxury Identity Consultancy for Modern Sophistication.",
      num: 225
    },
    {
      img: We_Transform_Fashion_magazine,
      url: '/stories/We_Transform_Fashion/',
      title: 'We Transform Fashion, Lifestyle and Personal Sophistication into a Powerful Expression of Who You Are.',
      num: 226
    },
    {
      img: Why_Successful_Founders_magazine,
      url: '/stories/Why_Successful_Founders/',
      title: 'Why Successful Founders Outgrow Their Image -  and What Comes Next?',
      num: 227
    },
    {
      img: Cover_Luxury_Is_Not_Fashion,
      url: '/stories/Luxury_Is_Not_Fashion/',
      title: "The Future of Luxury Is Not Fashion. It's Identity.",
      num: 228
    },
    {
      img: Women_CEO_Next_Level_magazine,
      url: '/stories/Women_CEO_Next_Level/',
      title: "Martin's House Concepts: The Executive Identity Maison for Women CEOs Entering Their Next Level.",
      num: 229
    },
    {
      img: Cover_The_Cost3,
      url: '/stories/The_Cost/',
      title: 'The Cost of Being Exceptional - And Why Most Women Are Never Told.',
      num: 230
    },
    {
      img: Cover_When_Success_Changes,
      url: '/stories/When_Success_Changes/',
      title: 'When Success Changes You Faster Than Your Identity Can Adapt.',
      num: 231
    },
    {
      img: Exceptional_Women_magazine,
      url: '/stories/Exceptional_Women/',
      title: "Exceptional Women Eventually Outgrow Their Identity. Here's Why.",
      num: 232
    },
    {
      img: the_reason_magazine,
      url: '/stories/The_Reason/',
      title: "The Reason - The Final Version of You Found Martin's House.",
      num: 233
    },
    {
      img: Cover_Sillage,
      url: '/stories/Sillage/',
      title: 'Sillage: The Invisible Trail Exceptional Women Leave Behind.',
      num: 234
    },
    {
      img: Your_Resume_magazine,
      url: '/stories/Your_Resume/',
      title: 'Your Sillage Is Stronger Than Your Resume.',
      num: 235
    },
    {
      img: Luxury_Price_magazine,
      url: '/stories/Luxury_Price/',
      title: "Luxury Is Not a Price Point. It's an Identity.",
      num: 236
    },
    {
      img: Luxury_business_magazine,
      url: '/stories/Luxury_business/',
      title: 'Why Some Businesses Become Luxury Brands and Others Never Do.',
      num: 237
    },
    {
      img: Cover_The_Difference2,
      url: '/stories/The_Difference/',
      title: 'The Difference Between a Business and a Luxury Business.',
      num: 238
    },
    {
      img: Cover_Most_Businesses,
      url: '/stories/Most_Businesses/',
      title: 'Most Businesses Sell Products - Luxury Brands Sell Meaning.',
      num: 239
    },
    {
      img: Cover_The_Wardrobe_of_Influence2,
      url: '/stories/The_Wardrobe_of_Influence/',
      title: "The Wardrobe of Influence Begins Here: Martin's House Executive Wear for Women Who Decide the Future.",
      num: 240
    },
    {
      img: Luxury_Creativity_magazine,
      url: '/stories/Luxury_Creativity/',
      title: "Monday Begins with Luxury Creativity: The Martin's House Foundation for Women Who Lead the Future.",
      num: 241
    },
    {
      img: Cover_Vision,
      url: '/stories/Vision/',
      title: "The  Martin's House Vision for the Next Six Months, One Year and Five Years.",
      num: 242
    },
    {
      img: Cover_The_Most,
      url: '/stories/The_most/',
      title: "The Most Valuable Asset of a Woman CEO Is Not Her Company - it's Her Judgment.",
      num: 243
    },
    {
      img: Cover_Extravaganza,
      url: '/stories/Extravaganza/',
      title: 'The Ultimate Extravaganza for Your Business.',
      num: 244
    },
    {
      img: Cover2_Hides_Mysteries,
      url: '/stories/Hides_Mysteries/',
      title: 'Luxury Executive-Identity-Wear Hides Mysteries.',
      num: 245
    },
    {
      img: Luxury_Begins_magazine,
      url: '/stories/Luxury_Begins/',
      title: 'Luxury Begins When You Stop Chasing Attention.',
      num: 246
    },
    {
      img: Cover_2_The_Architecture3,
      url: '/stories/The_Architecture/',
      title: 'The Architecture of Authority: Why the Most Valuable Asset of a Woman CEO is Her Identity.',
      num: 247
    },
    {
      img: Cover_2_Decision_Fatigue3,
      url: 'https://medium.com/@themartinshouse/the-hidden-drain-on-your-executive-focus-isnt-your-inbox-027143f0882c',
      title: "The Hidden Drain on Your Executive Focus Isn't Your Inbox.",
      num: 248
    },
    {
      img: Cover_2_Hire_Creatives3,
      url: 'https://medium.com/@themartinshouse/we-dont-hire-creatives-we-deploy-agents-03b4ad21c334',
      title: "We don't hire Creatives - we deploy Agents.",
      num: 249
    },
    {
      img: Cover_2_Code_Couture3,
      url: 'https://medium.com/@themartinshouse/code-couture-and-certainty-why-the-global-c-suite-demands-an-architectural-approach-to-personal-4a4bc59a1faa',
      title: 'Code, Couture, and Certainty: Why the Global C-Suite Demands an Architectural Approach to Personal Identity.',
      num: 250
    },
    {
      img: Cover_2_Agent_Blueprint3,
      url: 'https://medium.com/@themartinshouse/the-agents-blueprint-engineering-seamless-digital-journeys-and-flawless-physical-styling-for-uhnw-15858e16612c',
      title: "The Agent's Blueprint: Engineering Seamless Digital Journeys and Flawless Physical Styling for UHNW Decision-Makers.",
      num: 251
    },
    {
      img: Cover_2_High_Ticket3,
      url: 'https://medium.com/@themartinshouse/the-high-ticket-interface-melding-frontend-engineering-elite-cx-and-power-fashion-for-global-fd4bf65690e9',
      title: 'The High-Ticket Interface: Melding Frontend Engineering, Elite CX, and Power Fashion for Global Female Founders.',
      num: 252
    },
    {
      img: Cover_2_legacy_perfume,
      url: 'https://medium.com/@themartinshouse/the-architecture-of-authority-why-legacy-extrait-de-parfum-is-the-new-masterpiece-for-the-global-2b0b555428f1',
      title: 'The Architecture of Authority: Why "Legacy" Extrait de Parfum is the New Masterpiece for the Global Woman CEO.',
      num: 253
    },
    {
      img: Cover_2_Build_Legacies3,
      url: 'https://medium.com/@themartinshouse/we-build-legacies-the-agent-approach-to-executive-wardrobe-architecture-38fdf673ab21',
      title: 'We Build Legacies: The Agent Approach to Executive Wardrobe Architecture.',
      num: 254
    },
    {
      img: Cover_2_Visual_Discretion3,
      url: 'https://medium.com/@themartinshouse/the-visual-discretion-protocol-curating-high-end-fashion-and-digital-interfaces-for-8d0c519458c5',
      title: 'The Visual Discretion Protocol: Curating High-End Fashion and Digital Interfaces for Ultra-High-Net-Worth Privacy.',
      num: 255
    },
    {
      img: Cover_2_Structural_Blueprint3,
      url: 'https://medium.com/@themartinshouse/the-structural-blueprint-of-c-suite-portability-engineering-the-daniell-london-bag-trilogy-029c1e51b4b9',
      title: 'The Structural Blueprint of C-Suite Portability: Engineering the Daniell London Bag Trilogy.',
      num: 256
    },
    {
      img: Cover_2_Chanel_N5_4,
      url: 'https://danielllondon.substack.com/p/perfume-reviews-chanel-n-5-for-women',
      title: 'The Monochrome Monolith: Chanel №5, Material Contrast, and the Architecture of Permanent Presence.',
      num: 257
    },
    {
      img: Cover_2_Life_Hard3,
      url: 'https://medium.com/@themartinshouse/lifes-hard-make-it-harder-the-sovereign-architecture-of-building-from-scratch-c2238081e079',
      title: "Life's Hard, Make It Harder: The Sovereign Architecture of Building from Scratch.",
      num: 258
    },
    {
      img: Cover_2_Coco_Mademoiselle2,
      url: 'https://danielllondon.substack.com/p/perfume-reviews-coco-mademoiselle',
      title: 'The Amber Matrix: Coco Mademoiselle, Warm Materiality, and the Strategy of Unapologetic Vitality.',
      num: 259
    },
    {
      img: Cover_2_Obsessed3,
      url: 'https://medium.com/@themartinshouse/to-be-obsessed-with-yourself-requires-danger-f0d854bfd2d5',
      title: 'To Be Obsessed with Yourself Requires Danger.',
      num: 260
    },
    {
      img: Cover_2_joy5,
      url: 'https://danielllondon.substack.com/p/perfume-review-joy-dior-for-women',
      title: 'The Luminous Monolith: Joy by Dior and the Architecture of Sovereign Radiance.',
      num: 261
    },
    {
      img: Cover_2_Minimalist4,
      url: 'https://medium.com/@themartinshouse/the-minimalist-vantage-engineering-the-mini-dress-as-corporate-infrastructure-for-the-ultra-modern-1fa3a2e1750c',
      title: 'The Minimalist Vantage: Engineering the Mini Dress as Corporate Infrastructure for the Ultra-Modern CEO.',
      num: 262
    },
    {
      img: Cover_2_Tolerance3,
      url: 'https://medium.com/@themartinshouse/the-1-4mm-tolerance-why-the-ultra-modern-female-ceo-demands-outfit-architecture-not-fashion-924b57012b34',
      title: 'The 1.4mm Tolerance: Why the Ultra-Modern Female CEO Demands Outfit Architecture, Not Fashion.',
      num: 263
    },
    {
      img: Cover_2_Pardox3,
      url: 'https://danielllondon.substack.com/p/perfume-review-paradox-prada-for',
      title: 'The Paradox of Leverage: Prada, Non-Linear Geometry, and the Architecture of Controlled Disruption.',
      num: 264
    },
    {
      img: Cover_2_Engineering_Identity3,
      url: 'https://medium.com/@themartinshouse/the-architecture-of-presence-engineering-identity-wear-for-the-non-linear-executive-b6789087d080',
      title: 'The Architecture of Presence: Engineering Identity Wear for the Non-Linear Executive.',
      num: 265
    },
    {
      img: Cover_2_YellowDark4,
      url: 'https://medium.com/@themartinshouse/the-solar-monolith-yellow-dark-amber-and-the-strategy-of-chromatic-dominance-8ac38193a717',
      title: 'The Solar Monolith: Yellow, Dark Amber, and the Strategy of Chromatic Dominance.',
      num: 266
    },
    {
      img: Cover_2_JasminBag4,
      url: 'https://danielllondon.substack.com/p/perfume-review-jasmin-des-anges-esprit',
      title: 'The Late-Dusk Monolith: Jasmin des Anges Esprit de Parfum and the Architecture of Controlled Opulence.',
      num: 267
    },
    {
      img: Cover_2_Patek4,
      url: 'https://medium.com/@themartinshouse/the-mechanical-wrist-patek-philippe-nautilus-material-sync-and-the-calculus-of-temporal-f26eea76f2f5',
      title: 'Patek Philippe Nautilus, Material Sync, and the Calculus of Temporal Authority.',
      num: 268
    },
    {
      img: Cover_2_Sandals3,
      url: 'https://medium.com/@themartinshouse/pitch-angles-and-power-postures-deconstructing-the-mechanical-scaffolding-of-the-corporate-heel-c7fe65383f44',
      title: 'Pitch Angles and Power Postures: Deconstructing the Mechanical Scaffolding of the Corporate Heel.',
      num: 269
    },
    {
      img: Cover_2_life_walk3,
      url: 'https://medium.com/@themartinshouse/the-walk-of-life-mechanical-stance-and-the-geometry-of-the-sovereign-step-34fa407446a8',
      title: 'The Walk of Life: Mechanical Stance and the Geometry of the Sovereign Step.',
      num: 270
    },
    {
      img: Cover_2_portrait_lady5,
      url: 'https://medium.com/@themartinshouse/the-olfactory-monolith-frederic-malles-portrait-of-a-lady-and-the-calculus-of-the-unbending-line-9c9f6bd1474b',
      title: "The Olfactory Monolith: Frederic Malle's Portrait of a Lady and the Calculus of the Unbending Line.",
      num: 271
    },
    {
      img: Cover_2_Alignment3,
      url: 'https://medium.com/@themartinshouse/obsidian-alignment-synchronising-flawless-shoe-finishes-with-high-ticket-leather-b1439de3f693',
      title: 'Obsidian Alignment: Synchronising Flawless Shoe Finishes with High-Ticket Leather.',
      num: 272
    },
    {
      img: Cover_2_Cipriani3,
      url: 'https://danielllondon.substack.com/p/the-spatial-premium-casa-cipriani',
      title: 'The Premium: Casa Cipriani New York and the Architecture of Night Footwear.',
      num: 273
    },
    {
      img: Cover_2_Beyond_Luxury3,
      url: 'https://danielllondon.substack.com/p/beyond-luxury-why-the-modern-female',
      title: 'Beyond Luxury: Why the Modern Female Chair Requires Identity Engineering, Not Fashion Consulting.',
      num: 274
    },
    {
      img: Cover_2_Bob3,
      url: 'https://medium.com/@themartinshouse/the-encrypted-stance-eight-bobs-true-scarcity-and-the-biomechanics-of-the-patent-heel-a4c9e5ae7d7a',
      title: "The Encrypted Stance: Eight & Bob's True Scarcity and the Biomechanics of the Patent Heel.",
      num: 275
    },
    {
      img: Cover_2_prairie3,
      url: 'https://medium.com/@themartinshouse/the-architectural-canvas-la-prairie-skin-caviar-and-the-engineering-of-the-dermal-matrix-4efabf0c71e9',
      title: 'The Architectural Canvas: La Prairie Skin Caviar and the Engineering of the Dermal Matrix.',
      num: 276
    },
    {
      img: Cover_2_Dress_Code3,
      url: 'https://medium.com/@themartinshouse/the-uniform-of-governance-engineering-the-mandatory-dress-code-for-multinational-board-chairs-4d401ea03a89',
      title: 'The Uniform of Governance: Engineering the Mandatory Dress Code for Multinational Board Chairs.',
      num: 277
    },
    {
      img: Cover_2_Elite_Private,
      url: 'https://medium.com/@themartinshouse/the-enclave-standard-why-elite-private-member-clubs-fail-to-control-visual-static-and-how-to-fix-65c7aa27b90f',
      title: 'The Enclave Standard: Why Elite Private Member Clubs Fail to Control Visual Static (And How to Fix It).',
      num: 278
    },
    {
      img: Cover_2_Libre3,
      url: 'https://medium.com/@themartinshouse/the-asymmetric-lever-yves-saint-laurent-libre-and-the-foug%C3%A8re-inversion-of-corporate-authority-1d2c2621f236',
      title: 'The Asymmetric Lever: Yves Saint Laurent Libre and the Fougère Inversion of Corporate Authority.',
      num: 279
    },
    {
      img: Cover_2_Protocol_DL3,
      url: 'https://medium.com/@themartinshouse/the-dynastic-protocol-why-naming-an-executives-uniform-after-her-surname-is-the-ultimate-0953d111bc30',
      title: 'The Dynastic Protocol: Why Naming an Executive’s Uniform After Her Surname is the Ultimate Corporate Architecture.',
      num: 280
    },
    {
      img: Cover_2_Global3,
      url: 'https://medium.com/@themartinshouse/why-global-women-ceos-require-rigorous-dress-code-engineering-not-luxury-fashion-trends-73e9224b9cec',
      title: 'Why Global Women CEOs Require Rigorous Dress Code Engineering, Not Luxury Fashion Trends.',
      num: 281
    },
    {
      img: Cover_2_Executive_Wardrobe4,
      url: 'https://medium.com/@themartinshouse/the-executive-wardrobe-is-not-a-collection-its-an-architecture-d8ed546cae68',
      title: "The Executive Wardrobe Is Not a Collection. It's an Architecture.",
      num: 282
    },
    {
      img: Cover_2_Executive_Handbag4,
      url: 'https://medium.com/@themartinshouse/why-the-executive-handbag-is-part-of-the-dress-code-enforcing-the-table-perimeter-under-boardroom-d811ac0e9ab5',
      title: 'Why the Executive Handbag Is Part of the Dress Code: Enforcing the Table Perimeter under Boardroom Downlighting.',
      num: 283
    },
    {
      img: Cover_2_Franfance3,
      url: 'https://medium.com/@themartinshouse/what-fragrance-has-to-do-with-executive-presence-the-unseen-grid-of-spatial-command-6c9cc3d94303',
      title: 'What Fragrance Has to Do With Executive Presence: The Unseen Grid of Spatial Command.',
      num: 284
    },
    {
      img: Cover_2_Coat3,
      url: 'https://medium.com/@themartinshouse/why-the-ceos-coat-is-not-an-outer-layer-engineering-the-environmental-threshold-across-borders-a010c0f9ae97',
      title: "Why the CEO's Coat Is Not an Outer Layer: Engineering the Environmental Threshold Across Borders and Architecture.",
      num: 285
    },
    {
      img: Cover_2_Errors3,
      url: 'https://medium.com/@themartinshouse/the-five-errors-of-an-unengineered-executive-wardrobe-e5850ffa497f',
      title: 'The Five Errors of an Unengineered Executive Wardrobe.',
      num: 286
    },
    {
      img: Cover_2_CEOBrand3,
      url: 'https://medium.com/@themartinshouse/the-ceo-is-not-a-brand-why-executive-identity-is-deeper-than-personal-branding-d32f68221139',
      title: 'The CEO Is Not a Brand: Why Executive Identity Is Deeper Than Personal Branding.',
      num: 287
    },
    {
      img: Cover_2_Prestige_Dior3,
      url: 'https://medium.com/@themartinshouse/dior-prestige-la-micro-huile-de-rose-activated-serum-the-architecture-of-care-52bd87b684a8',
      title: 'Dior Prestige La Micro-Huile de Rose Activated Serum: The Architecture of Care.',
      num: 288
    },
    {
      img: Cover_2_Yourself3,
      url: 'https://medium.com/@themartinshouse/the-difference-between-looking-successful-and-looking-like-yourself-106375b9dba8',
      title: 'The Difference Between Looking Successful and Looking Like Yourself.',
      num: 289
    },
    {
      img: Cover_2_Between3,
      url: 'https://medium.com/@themartinshouse/the-open-ankle-code-daniell-london-dress-code-engineering-24d3f02813a0',
      title: 'The Open Ankle Code: Daniell London - Dress Code Engineering.',
      num: 290
    },
    {
      img: Cover_2_Details3,
      url: 'https://medium.com/@themartinshouse/you-create-the-collection-we-engineer-the-details-83b9c0113d27',
      title: 'You Create the Collection. We Engineer the Details.',
      num: 291
    },
    {
      img: Cover_2_LaMaraina,
      url: 'https://medium.com/@themartinshouse/your-campaign-deserves-its-own-digital-experience-78ea606d7a5d',
      title: 'Your Campaign Deserves Its Own Digital Experience.',
      num: 292
    },
    {
      img: Cover_2_Beyond_Price3,
      url: 'https://medium.com/@themartinshouse/beyond-the-price-of-perfume-baccarat-les-larmes-sacr%C3%A9es-de-th%C3%A8bes-38eb1a4b3608',
      title: 'Beyond the Price of Perfume: Baccarat Les Larmes Sacrées de Thèbes.',
      num: 293
    },
    {
      img: Cover_2_Signature3,
      url: 'https://medium.com/@themartinshouse/your-collection-has-a-signature-have-you-engineered-it-8cb0c5385530',
      title: 'Your Collection Has a Signature. Have You Engineered It?',
      num: 294
    },
    {
      img: Cover_2_HermesKelly3,
      url: 'https://medium.com/@themartinshouse/the-architecture-of-the-herm%C3%A8s-kelly-33eb6efd2cbe',
      title: 'The Architecture of the Hermès Kelly.',
      num: 295
    },
    {
      img: Cover_2_Sketch3,
      url: 'https://medium.com/@themartinshouse/from-sketch-to-engineered-detail-de5d4859a529',
      title: 'From Sketch to Engineered Detail.',
      num: 296
    },
    {
      img: Cover_2_Technical2,
      url: 'https://medium.com/@themartinshouse/the-technical-decisions-behind-a-luxury-mobile-experience-1bbcb8390df0',
      title: 'The Technical Decisions Behind a Luxury Mobile Experience.',
      num: 297
    },
    {
      img: Cover_2_Cuff3,
      url: 'https://medium.com/@themartinshouse/the-executive-cuff-code-e969df4f9307',
      title: 'The Executive Cuff Code.',
      num: 298
    },
    {
      img: Cover_2_services,
      url: 'https://medium.com/@themartinshouse/from-the-garments-details-to-the-campaign-s-experience-80e3c05bf693',
      title: "From the Garment's Details to the Campaign's Experience.",
      num: 299
    },
    {
      img: Cover_2_Luxury_Digital3,
      url: 'https://medium.com/@themartinshouse/can-a-digital-experience-express-the-character-of-a-luxury-house-cc5844675b8a',
      title: 'Can a Digital Experience Express the Character of a Luxury House?',
      num: 300
    },
    {
      img: Cover_2_Collar4,
      url: 'https://medium.com/@themartinshouse/collar-architecture-the-frame-of-authority-954d5110ca9c',
      title: 'Collar Architecture: The Frame of Authority.',
      num: 301
    },
    {
      img: Cover_2_Decisions2,
      url: 'https://medium.com/@themartinshouse/designing-a-digital-signature-for-a-woman-ceo-7300a53a93c6',
      title: 'Designing a Digital Signature for a Woman CEO.',
      num: 302
    },
    {
      img: Cover_2_Clive3,
      url: 'https://medium.com/@themartinshouse/the-architecture-of-imperial-majesty-when-perfume-is-an-object-of-rarity-4addc8cb5b9e',
      title: 'The Architecture of Imperial Majesty: When Perfume is an Object of Rarity.',
      num: 303
    },
    {
      img: Cover_2_Beyond3,
      url: 'https://medium.com/@themartinshouse/beyond-the-wardrobe-engineering-a-complete-woman-ceo-identity-0fe62048cccc',
      title: 'Beyond the Wardrobe: Engineering a Complete Woman CEO Identity.',
      num: 304
    },
    {
      img: Cover_2_News_digital2,
      url: 'https://medium.com/@themartinshouse/luxury-campaigns-digital-intelligence-engineering-decisions-2113006fab3a',
      title: 'Luxury Campaigns. Digital Intelligence. Engineering Decisions.',
      num: 305
    }
  ],
  THmartinsEditorial: [
    {
      img: notrends_magazine,
      url: 'https://medium.com/p/66d0844ec1b3?postPublishedType=initial',
      num: 0
    },
    {
      img: powerbrand_magazine,
      url: 'https://medium.com/@thmartinsCEO/the-architecture-of-restraint-why-the-most-powerful-brands-whisper-instead-of-shout-3bf006817b91',
      num: 1
    },
    {
      img: contract_magazine,
      url: 'https://medium.com/@thmartinsCEO/fashion-is-the-first-contract-you-sign-with-the-world-dfb17a2c8201',
      num: 2
    },
    {
      img: precision_magazine,
      url: 'https://medium.com/@thmartinsCEO/tuesday-requires-precision-what-a-woman-ceo-wears-when-decisions-deepen-7392df3b78a2',
      num: 3
    },
    {
      img: blackandwhite_magazine,
      url: 'https://medium.com/@thmartinsCEO/black-white-and-the-psychology-of-certainty-a00dc6cff9d7',
      num: 4
    },
    {
      img: mechanical_magazine,
      url: 'https://medium.com/@martinswriters/time-as-strategy-the-modern-womans-relationship-with-mechanical-mastery-b971da1178a6',
      num: 5
    },
    {
      img: letterCEO_magazine,
      url: 'https://medium.com/@martinswriters/a-letter-to-the-woman-who-does-not-chase-minutes-she-architects-decades-5d5804a702ed',
      num: 6
    },
    {
      img: burgundywhite_magazine,
      url: 'https://medium.com/@thmartinsCEO/burgundy-is-an-attraction-and-white-is-a-legacy-the-wise-ceo-choice-0f7e2badc07d',
      num: 7
    },
    {
      img: privateuniform_magazine,
      url: 'https://medium.com/@thmartinsCEO/the-private-uniform-why-powerful-women-repeat-what-they-wear-45b794c5f9d0',
      num: 8
    },
    {
      img: waitingfor_magazine,
      url: 'https://medium.com/@thmartinsCEO/the-ceo-collection-you-have-been-waiting-for-efdc82b716c8',
      num: 9
    },
    {
      img: invisiblelogos_magazine,
      url: 'https://medium.com/@thmartinsCEO/invisible-logos-visible-power-the-era-of-discreet-dominance-d0803d03b2be',
      num: 10
    },
    {
      img: weeksystem_magazine,
      url: 'https://medium.com/@thmartinsCEO/the-week-is-a-system-how-a-woman-ceo-uses-clothing-to-stay-one-step-ahead-ee3bf09d5e38',
      num: 11
    },
    {
      img: atelier_magazine,
      url: 'https://medium.com/@thmartinsCEO/from-the-atelier-to-authority-when-a-fashion-house-turns-into-a-leadership-scheme-8c63fc4204d9',
      num: 12
    },
    {
      img: covenantfashion_magazine,
      url: '/stories/Paris_vs_Italy/',
      title: 'Paris vs Itália: Two Languages of Power Dressing. Structure vs Sensuality - Discipline vs Expression.',
      num: 13
    },
    {
      img: highnetworth_magazine,
      url: '/stories/High_Net_Worth_Identity/',
      title: 'High-Net-Worth Identity Requires High-Level Design.',
      num: 14
    },
    {
      img: nextlevel_magazine,
      url: '/stories/The_Next_Level_of_Leadership/',
      title: 'The Next Level of Leadership Is Invisible, Intentional, and Impeccably Designed.',
      num: 15
    },
    {
      img: vitalidentity_magazine,
      url: '/stories/Luxury_Is_No_Longer_Fashionable/',
      title: 'Luxury Is No Longer Fashionable - It Is a Vital Identity.',
      num: 16
    },
    {
      img: worldinfluence_magazine,
      url: '/stories/Luxury_Bags_Designed_for_Women_Who_Influence_the_World/',
      title: 'Victory-Fashion Concepts Presents: Luxury Bags Designed for Women Who Influence the World.',
      num: 17
    },
    {
      img: thehat_magazine,
      url: '/stories/Beyond_Accessories/',
      title: 'Beyond Accessories: The Hat as a Strategic Symbol of Executive Authority.',
      num: 18
    },
    {
      img: beyondfashion_magazine,
      url: '/stories/Beyond_Fashion_and_Status/',
      title: 'Beyond Fashion and Status: Welcome to Victory-Executive Luxury.',
      num: 19
    },
    {
      img: privateissue_magazine,
      url: '/stories/The_Covenant_Collection_Private_Issue_I/',
      title: 'The Covenant Collection - Private Issue I',
      num: 20
    },
    {
      img: luxurybags_magazine,
      url: '/stories/Luxury_Bags_Designed/',
      title: 'Victory - Fashion Concepts Presents: Luxury Bags Designed for Women Who Inspire the World.',
      num: 21
    },
    {
      img: InfluenceIsTailored_magazine,
      url: '/stories/Influence_Is_Tailored/',
      title: 'Influence Is Tailored: Victory-Executive Luxury Designs the Identity of the Modern Woman CEO.',
      num: 22
    },
    {
      img: Most_Powerful_Women_magazine,
      url: '/stories/Most_Powerful_Women/',
      title: "The World's Most Powerful Women Don't Follow Trends - They Set Them.",
      num: 23
    },
    {
      img: New_Expression_magazine,
      url: '/stories/New_Expression_of_Identity/',
      title: 'Introducing a New Expression of Identity - Designed for Women Who Lead.',
      num: 24
    },
    {
      img: Prioritise_Leadership_magazine,
      url: '/stories/Prioritise_Leadership/',
      title: 'Victory - Executive Luxury: Businesswear for Female CEOs Who Prioritise Leadership Over Headlines.',
      num: 25
    },
    {
      img: Female_Empowerment_magazine,
      url: '/stories/Female_Empowerment/',
      title: 'From the Boardroom to Legacy: Victory-Executive Luxury Creates the Uniform of Female Empowerment.',
      num: 26
    },
    {
      img: The_Executive_Woman_magazine,
      url: '/stories/The_Executive_Woman/',
      title: "The Executive Woman and The Woman CEO - What's to Wear Between the Lines?",
      num: 27
    },
    {
      img: Daniell_London_magazine,
      url: '/stories/Daniell_London/',
      title: "Martin's House Presents Daniell-London: Where Fashion, Lifestyle and Executive Sophistication Become One.",
      num: 28
    },
    {
      img: Beyond_Styling_magazine,
      url: '/stories/Beyond_Styling/',
      title: 'Beyond Styling: Daniell Introduces a New Era of Fashion, Presence and Luxury Identity.',
      num: 29
    },
    {
      img: The_Future_of_Luxury_magazine,
      url: '/stories/The_Future_of_Luxury/',
      title: "The Future of Luxury Is Not Fashion - It's Identity.",
      num: 30
    }
  ],
  magazine: [
    {
      img: fashionStories,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'START YOUR WEEK CONFIDENT AND STYLISH:',
      title2: 'BE ATTACHED TO YOURSELF!',
      desc: "Did you realise that the clothes you wear can change the vibe of your whole week? Imagine starting your Monday feeling fresh, youthful, and stylish — how awesome would that be? Don't you think Mondays have the potential to be vibrant and motivating instead of feeling dull and dreary?",
      suggestion: 'Read the story'
    },
    {
      media: '/media/energize_yourself.mp4',
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'PHYSICAL EXERCISE:',
      title2: 'YOUR GATEWAY TO FITNESS',
      desc: 'In today’s fast-moving world, it’s easy to get immersed in a phase of unhealthy living. Sitting at a table for hours, eating on the go and not having any entertainment can leave you feeling exhausted and uninspired. But what if I told you there is a way to supercharge your energy...',
      suggestion: 'Read the story'
    },
    {
      img: lipstick,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'ATTRACTION AND ELEGANCE:',
      title2: 'TOP BEAUTY TRENDS FOR WOMEN IN 2025',
      desc: 'Get ready to redefine beauty in 2025! This year’s top beauty trends are here to make you look and feel your absolute best! So, whether you’re seeking to enhance your natural elegance or make bold, unforgettable statements, the latest trends are going to be extraordinary for everyone!',
      suggestion: 'Read the story'
    },
    {
      media: '/media/israel_country.mp4',
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'VISITING ISRAEL:',
      title2: 'EXPLORING ISRAEL’S HISTORIC AND RELIGIOUS WONDERS',
      desc: 'Have you always dreamed of promenading in the steps of the past? Israel, the land of ancient fascination and modern marvels, offers an experience like no other. From the cradle of religious history to bustling metropolises and delectable food, Israel is a destination that promises...',
      suggestion: 'Read the story'
    },
    {
      img: apps,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'TRANSFORM YOUR LIFE WITH THE MOST',
      title2: 'USEFUL AI-POWERED APPLICATIONS.',
      desc: 'Many people mistakenly believe that AI will replace creativity or fundamentally change human existence. However, the reality is that AI is designed to complement our routines, improve efficiency, and save time. Instead of fearing the unknown, it’s time to embrace these tools that help us thrive.',
      suggestion: 'Read the story'
    },
    {
      img: pregnant,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'FASHION FOR PREGNANT WOMEN:',
      title2: 'STYLE AND COMFORT DURING PREGNANCY.',
      desc: 'Pregnancy is an inspiring journey that changes women in wonderful ways. While it is sensational to learn about it, many mothers find it difficult to look their best while pregnant. Maternity fashion has become a combination of common sense and style. With so many options, expectant mothers...',
      suggestion: 'Read the story'
    },
    {
      img: valentines,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'VALENTINE’S DAY IS ALMOST HERE:',
      title2: 'YOUR “I LOVE YOU” SHOPPING BAG!',
      desc: 'Get ready to grasp the emotion of Valentine’s Day. It’s almost here! The countdown is on, and it’s the perfect moment to discover the superb Valentines day gift for an unforgettable celebration. Whether surprising a significant other, cherishing a dear friend, or treating yourself, early preparations...',
      suggestion: 'Read the story'
    },
    {
      img: portugal,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'AN ADVENTURE ACROSS MY HOMELAND:',
      title2: 'PORTUGAL THE GEMSTONE ON EARTH!',
      desc: 'Some people might think Portugal, this captivating country, is the jewel of Europe or even the gemstone of the world. This land of God has always been known as a holiday shelter, peaceful and a refuge for anyone across the planet. There’s no doubt about the Portuguese good taste for food, a flavorful...',
      suggestion: 'Read the story'
    },
    {
      img: books,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'TOP 10 BEST BOOKS FOR SELF-GROWTH',
      title2: 'SPIRITUALITY, AND PERSONALITY DEVELOPMENT',
      desc: 'Books are our greatest companions on the journey of personal growth. They teach, inspire, and guide us toward the paths we aspire to take, helping us become the best versions of ourselves. As wise men say, words have the power to transform our lives in profound ways. For centuries, books have been a gateway...',
      suggestion: 'Read the story'
    },
    {
      img: women_30,
      smalltitle: 'STORIES & SPECTRUM - LIFESTYLE MAGAZINE',
      title1: 'CHIC, PROFESSIONAL, AND CASUAL',
      title2: 'MASTERING FASHION FOR WOMEN OVER 30',
      desc: 'Embracing style beyond 30, where sophistication meets individuality, fashion becomes less about trends and more about refining a dresser that blends comfort with splendour. Trends choices ultimately evolve into greater assurance, professional quality, and one-of-a-kind style...',
      suggestion: 'Read the story'
    },
    {
      img: ai_not_creative,
      smalltitle: "MARTIN'S - FASHION & LIFESTYLE MAGAZINE",
      title1: 'AI IS NOT CREATIVE; THE HUMAN RACE IS.',
      title2: 'WILL AI REPLACE HUMANS IN THE FUTURE?',
      desc: 'The first time AI met the human race, it had a tremendous impact on our society, the fear of losing jobs and how to generate income was imminent. The unbelievable growth of artificial intelligence (AI) has transformed many industries. From machine learning to natural language processing...',
      suggestion: 'Read the story'
    },
    {
      img: your_story,
      smalltitle: "MARTIN'S - FASHION & LIFESTYLE MAGAZINE",
      title1: 'THE TALE OF YOUR SOUL HAS BEEN WRITTEN,',
      title2: 'BUT YOU ARE NOT AWARE!',
      desc: 'Beyond our existence, someone wrote our story with every little detail. Every word we speak and every step we take has already been written but we are not aware of it. The world is one big, beautiful tapestry of narratives, each intricately and wonderfully woven in ways we hardly recognise...',
      suggestion: 'Read the story'
    },
    {
      img: gemstonesblog,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'WOMEN IN HIGH FASHION ARE GEMSTONES',
      title2: 'IN EVERY COLOUR!',
      desc: "Every woman on this planet is a gemstone, the most beautiful being ever created! Remember, high fashion isn't what you put on your body; it's what you dress your inner you with! High fashion is an awe-inspiring world of pure abundance, creativity, and timeless charm, delicacy, dignity, luxury and grace...",
      suggestion: 'Read the story'
    },
    {
      img: gardenmag,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'WELCOME TO OUR BEAUTIFUL GARDEN!',
      title2: 'A FASHION WONDERLAND.',
      desc: 'Welcome to our lovely garden, where fashion looks amazing and creativity is everywhere. Come and visit this magical place, where style, elegance and storytelling all come together. This is not just a garden—it is a runway of dreams, where each outfit is a masterpiece, waiting to be admired...',
      suggestion: 'Read the story'
    },
    {
      img: futureinst,
      smalltitle: "MARTIN'S - FASHION & LIFESTYLE MAGAZINE",
      title1: 'YOU ARE THE FUTURE OF',
      title2: 'FASHION WRITING.',
      desc: 'This modern, stylish evening jumpsuit has a smooth, tight fit, with see-through parts and decorations that look like diamonds. The colours are a mix of white, pink, blue and black, which makes it look both elegant and strong. Writing about fashion has always been an important part of the fashion industry...',
      suggestion: 'Read the story'
    },
    {
      img: luxurymag,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'THE INTERSECTION OF ELEGANCE AND LUXURY',
      title2: 'PERFECT EVENING FOR WOMEN OVER 40',
      desc: 'Fashion is timeless, and for women over 40, dressing elegantly for an evening occasion is about embracing confidence, sophistication, and effortless style. A well-tailored blazer paired with high-fashion evening trousers in chic spring/summer 2025 shades of white, brown and cream is the epitome of refined glamour...',
      suggestion: 'Read the story'
    },
    {
      img: women40_blog,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'THE EVOLUTION OF EVENING WEAR:',
      title2: 'BOLD ELEGANCE IN WHITE AND BURGUNDY',
      desc: 'Fashion is so exciting! It’s always changing, and it’s a great way to express yourself and be practical at the same time. For women over 40, the evolution of fashion is an invigorating journey toward embracing one’s individuality, celebrating personal style, and redefining elegance...',
      suggestion: 'Read the story'
    },
    {
      img: yourstory_blog,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'YOUR STORY - OUR WORDS:',
      title2: 'THE ART OF FASHION WRITING.',
      desc: 'Fashion is so much more than just clothing; it’s a way of expressing your personality and a powerful way of communicating who you are. Whether you’re all about that bold streetwear vibe or you’re into the high-end haute couture, fashion is a way to express yourself and tell your story...',
      suggestion: 'Read the story'
    },
    {
      img: blackwhite,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'THE DELIGHTFUL BLACK AND WHITE:',
      title2: 'AN AGELESS TALE OF SPLENDOUR.',
      desc: 'Fashion trends come and go, but some combinations will always be attractive. Black and white are two colours that represent the opposite ends of the colour wheel. Together, create a fabulous look that is also dramatic and timelessly luxurious. This powerful duo has been seen on the catwalks...',
      suggestion: 'Read the story'
    },
    {
      img: summertips,
      smalltitle: 'FASS-HION - FASHION MAGAZINE',
      title1: 'HOW TO DRESS WELL FOR YOUR EVENINGS THIS SUMMER?',
      title2: 'WE ASKED 5 LUXURY BRANDS FOR THEIR ADVICE',
      desc: "As the sun starts to shine, you'll receive invitations to the most fabulous evening gatherings, rooftop dinners and sunset soirées. Your summer evening wardrobe is about to become a superb blend of grace, comfort, and seasonal flair! So, whether you're stepping out for a candlelit dinner...",
      suggestion: 'Read the story'
    }
  ],
  tangoCollection: [
    {
      img: tango_1,
      num: 1
    },
    {
      img: tango_2,
      num: 2
    },
    {
      img: tango_3,
      num: 3
    },
    {
      img: tango_4,
      num: 4
    },
    {
      img: tango_5,
      num: 5
    },
    {
      img: tango_6,
      num: 6
    },
    {
      img: tango_7,
      num: 7
    },
    {
      img: tango_8,
      num: 8
    },
    {
      img: tango_9,
      num: 9
    },
    {
      img: tango_10,
      num: 10
    },
    {
      img: tango_11,
      num: 11
    },
    {
      img: tango_12,
      num: 12
    },
    {
      img: tango_13,
      num: 13
    },
    {
      img: tango_14,
      num: 14
    },
    {
      img: tango_15,
      num: 15
    },
    {
      img: tango_16,
      num: 16
    },
    {
      img: tango_17,
      num: 17
    }
  ],
  maskCollection: [
    {
      img: mask_1,
      num: 1
    },
    {
      img: mask_2,
      num: 2
    },
    {
      img: mask_3,
      num: 3
    },
    {
      img: mask_4,
      num: 4
    },
    {
      img: mask_5,
      num: 5
    },
    {
      img: mask_6,
      num: 6
    },
    {
      img: mask_7,
      num: 7
    },
    {
      img: mask_8,
      num: 8
    },
    {
      img: mask_9,
      num: 9
    },
    {
      img: mask_10,
      num: 10
    },
    {
      img: mask_11,
      num: 11
    },
    {
      img: mask_12,
      num: 12
    },
    {
      img: mask_13,
      num: 13
    },
    {
      img: mask_14,
      num: 14
    }
  ],
  leatherCollection: [
    {
      img: lth_1,
      num: 1
    },
    {
      img: lth_2,
      num: 2
    },
    {
      img: lth_3,
      num: 3
    },
    {
      img: lth_4,
      num: 4
    },
    {
      img: lth_5,
      num: 5
    },
    {
      img: lth_6,
      num: 6
    },
    {
      img: lth_7,
      num: 7
    },
    {
      img: lth_8,
      num: 8
    },
    {
      img: lth_9,
      num: 9
    },
    {
      img: lth_10,
      num: 10
    },
    {
      img: lth_11,
      num: 11
    },
    {
      img: lth_12,
      num: 12
    },
    {
      img: lth_13,
      num: 13
    }
  ],
  entrepreneurCollection: [
    {
      img: entre_1,
      num: 1
    },
    {
      img: entre_2,
      num: 2
    },
    {
      img: entre_3,
      num: 3
    },
    {
      img: entre_4,
      num: 4
    },
    {
      img: entre_5,
      num: 5
    },
    {
      img: entre_6,
      num: 6
    },
    {
      img: entre_7,
      num: 7
    },
    {
      img: entre_8,
      num: 8
    },
    {
      img: entre_9,
      num: 9
    },
    {
      img: entre_10,
      num: 10
    },
    {
      img: entre_11,
      num: 11
    },
    {
      img: entre_12,
      num: 12
    },
    {
      img: entre_13,
      num: 13
    },
    {
      img: entre_14,
      num: 14
    },
    {
      img: entre_15,
      num: 15
    },
    {
      img: entre_16,
      num: 16
    },
    {
      img: entre_17,
      num: 17
    },
    {
      img: entre_18,
      num: 18
    },
    {
      img: entre_19,
      num: 19
    },
    {
      img: entre_20,
      num: 20
    },
    {
      img: entre_21,
      num: 21
    },
    {
      img: entre_22,
      num: 22
    },
    {
      img: entre_23,
      num: 23
    },
    {
      img: entre_24,
      num: 24
    },
    {
      img: entre_25,
      num: 25
    },
    {
      img: entre_26,
      num: 26
    },
    {
      img: entre_27,
      num: 27
    },
    {
      img: entre_28,
      num: 28
    },
    {
      img: entre_29,
      num: 29
    },
    {
      img: entre_30,
      num: 30
    },
    {
      img: entre_31,
      num: 31
    },
    {
      img: entre_32,
      num: 32
    },
    {
      img: entre_33,
      num: 33
    },
    {
      img: entre_34,
      num: 34
    },
    {
      img: entre_35,
      num: 35
    }
  ],
  redCollection: [
    {
      img: ladyRed_1,
      num: 1
    },
    {
      img: ladyRed_2,
      num: 2
    },
    {
      img: ladyRed_3,
      num: 3
    },
    {
      img: ladyRed_4,
      num: 4
    },
    {
      img: ladyRed_5,
      num: 5
    },
    {
      img: ladyRed_6,
      num: 6
    },
    {
      img: ladyRed_7,
      num: 7
    },
    {
      img: ladyRed_8,
      num: 8
    },
    {
      img: ladyRed_9,
      num: 9
    },
    {
      img: ladyRed_10,
      num: 10
    }
  ],
  whiteCollection: [
    {
      img: white_1,
      num: 1
    },
    {
      img: white_2,
      num: 2
    },
    {
      img: white_3,
      num: 3
    },
    {
      img: white_4,
      num: 4
    },
    {
      img: white_5,
      num: 5
    },
    {
      img: white_6,
      num: 6
    },
    {
      img: white_7,
      num: 7
    },
    {
      img: white_8,
      num: 8
    },
    {
      img: white_9,
      num: 9
    },
    {
      img: white_10,
      num: 10
    },
    {
      img: white_11,
      num: 11
    },
    {
      img: white_12,
      num: 12
    },
    {
      img: blue_1,
      num: 13
    },
    {
      img: blue_2,
      num: 14
    },
    {
      img: blue_3,
      num: 15
    },
    {
      img: blue_4,
      num: 16
    },
    {
      img: blue_5,
      num: 17
    }
  ],
  diamondCollection: [
    {
      img: diamond_1,
      num: 1
    },
    {
      img: diamond_2,
      num: 2
    },
    {
      img: diamond_3,
      num: 3
    },
    {
      img: diamond_4,
      num: 4
    },
    {
      img: diamond_5,
      num: 5
    },
    {
      img: diamond_6,
      num: 6
    },
    {
      img: yellow_1,
      num: 7
    },
    {
      img: yellow_2,
      num: 8
    },
    {
      img: yellow_3,
      num: 9
    },
    {
      img: yellow_4,
      num: 10
    },

    {
      img: yellow_5,
      num: 11
    },
    {
      img: yellow_6,
      num: 12
    },
    {
      img: yellow_7,
      num: 13
    },
    {
      img: yellow_8,
      num: 14
    },
    {
      img: yellow_9,
      num: 15
    },
    {
      img: yellow_10,
      num: 16
    },
    {
      img: yellow_11,
      num: 17
    }
  ],
  goldCollection: [
    {
      img: gold_1,
      num: 1
    },
    {
      img: gold_2,
      num: 2
    },
    {
      img: gold_3,
      num: 3
    },
    {
      img: gold_4,
      num: 4
    },
    {
      img: gold_5,
      num: 5
    },
    {
      img: gold_6,
      num: 6
    },
    {
      img: gold_7,
      num: 7
    },
    {
      img: gold_8,
      num: 8
    },
    {
      img: gold_9,
      num: 9
    },
    {
      img: gold_10,
      num: 10
    },
    {
      img: gold_11,
      num: 11
    },
    {
      img: gold_12,
      num: 12
    },
    {
      img: gold_13,
      num: 13
    },
    {
      img: gold_14,
      num: 14
    },
    {
      img: gold_15,
      num: 15
    },
    {
      img: gold_16,
      num: 16
    },
    {
      img: gold_17,
      num: 17
    },
    {
      img: gold_18,
      num: 18
    },
    {
      img: gold_19,
      num: 19
    },
    {
      img: gold_20,
      num: 20
    },
    {
      img: gold_21,
      num: 21
    },
    {
      img: gold_22,
      num: 22
    },
    {
      img: gold_23,
      num: 23
    },

    {
      img: gold_24,
      num: 24
    },
    {
      img: gold_25,
      num: 25
    },
    {
      img: gold_26,
      num: 26
    },
    {
      img: gold_27,
      num: 27
    },
    {
      img: gold_28,
      num: 28
    },
    {
      img: gold_29,
      num: 29
    },
    {
      img: gold_30,
      num: 30
    },
    {
      img: gold_31,
      num: 31
    },
    {
      img: gold_32,
      num: 32
    },
    {
      img: gold_33,
      num: 33
    },
    {
      img: gold_34,
      num: 34
    },
    {
      img: gold_35,
      num: 35
    }
  ],
  collection: [
    {
      img: black_13,
      num: 1,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat',
      invest: '£1,500'
    },
    {
      img: black_14,
      num: 2,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_15,
      num: 3,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_2,
      num: 4,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_3,
      num: 5,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_4,
      num: 6,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_10,
      num: 7,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_6,
      num: 8,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_1,
      num: 9,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_16,
      num: 10,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_9,
      num: 11,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_5,
      num: 12,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_12,
      num: 13,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_11,
      num: 14,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_7,
      num: 15,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_8,
      num: 16,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_17,
      num: 17,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: black_18,
      num: 18,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: button_1,
      num: 19,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: button_2,
      num: 20,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: button_3,
      num: 21,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: button_4,
      num: 22,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: button_5,
      num: 23,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: button_6,
      num: 24,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: spring_1,
      num: 25,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: spring_2,
      num: 26,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: spring_3,
      num: 27,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: spring_4,
      num: 28,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: spring_5,
      num: 29,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    },
    {
      img: spring_6,
      num: 30,
      name: 'Miss N.',
      desc: 'A black and white Dress Coat with white lace.',
      invest: '£2,000'
    }
  ],
  symphonyCollection: [
    {
      img: symphony_1,
      num: 1
    },
    {
      img: symphony_2,
      num: 2
    },
    {
      img: symphony_3,
      num: 3
    },
    {
      img: symphony_4,
      num: 4
    },
    {
      img: symphony_5,
      num: 5
    },
    {
      img: symphony_6,
      num: 6
    },
    {
      img: symphony_7,
      num: 7
    },
    {
      img: symphony_8,
      num: 8
    },
    {
      img: symphony_9,
      num: 9
    },
    {
      img: symphony_10,
      num: 10
    },
    {
      img: symphony_11,
      num: 11
    },
    {
      img: symphony_12,
      num: 12
    },
    {
      img: symphony_13,
      num: 13
    },
    {
      img: symphony_14,
      num: 14
    },
    {
      img: symphony_15,
      num: 15
    },
    {
      img: symphony_16,
      num: 16
    },
    {
      img: symphony_17,
      num: 17
    },
    {
      img: symphony_18,
      num: 18
    },
    {
      img: orange_1,
      num: 19
    },
    {
      img: orange_2,
      num: 20
    },
    {
      img: orange_3,
      num: 21
    },
    {
      img: orange_4,
      num: 22
    },
    {
      img: orange_5,
      num: 23
    },
    {
      img: orange_6,
      num: 24
    },
    {
      img: orange_7,
      num: 25
    },
    {
      img: orange_8,
      num: 26
    }
  ],
  martinscollection: [
    {
      img: th1,
      num: 'TH1'
    },
    {
      img: th2,
      num: 'TH2'
    },
    {
      img: th3,
      num: 'TH3'
    },
    {
      img: th4,
      num: 'TH4'
    },
    {
      img: th5,
      num: 'TH5'
    },
    {
      img: th6,
      num: 'TH6'
    },
    {
      img: th7,
      num: 'TH7'
    },
    {
      img: th8,
      num: 'TH8'
    },
    {
      img: th9,
      num: 'TH9'
    },
    {
      img: th10,
      num: 'TH10'
    },
    {
      img: th11,
      num: 'TH11'
    },
    {
      img: th12,
      num: 'TH12'
    },
    {
      img: th13,
      num: 'TH13'
    },
    {
      img: th14,
      num: 'TH14'
    },
    {
      img: th15,
      num: 'TH15'
    },
    {
      img: th16,
      num: 'TH16'
    },
    {
      img: th17,
      num: 'TH17'
    },
    {
      img: th18,
      num: 'TH18'
    },
    {
      img: th19,
      num: 'TH19'
    },
    {
      img: th20,
      num: 'TH20'
    },

    {
      img: JFL1,
      num: 'JF1'
    },
    {
      img: JFL2,
      num: 'JF2'
    },
    {
      img: JFL3,
      num: 'JF3'
    },
    {
      img: JFL4,
      num: 'JF4'
    },
    {
      img: FL1,
      num: 'F1'
    },
    {
      img: FL2,
      num: 'F2'
    },
    {
      img: FL3,
      num: 'F3'
    },
    {
      img: FL5,
      num: 'F4'
    },
    {
      img: FL6,
      num: 'F5'
    },
    {
      img: FL7,
      num: 'F6'
    },
    {
      img: FL8,
      num: 'F7'
    },
    {
      img: FL9,
      num: 'F8'
    },
    {
      img: FL10,
      num: 'F9'
    },
    {
      img: stripes1,
      num: 'S1'
    },
    {
      img: stripes2,
      num: 'S2'
    },
    {
      img: stripes3,
      num: 'S3'
    },
    {
      img: stripes4,
      num: 'S4'
    },
    {
      img: stripes5,
      num: 'S5'
    },
    {
      img: stripes6,
      num: 'S6'
    },
    {
      img: stripes7,
      num: 'S7'
    },
    {
      img: stripes8,
      num: 'S8'
    },
    {
      img: stripes9,
      num: 'S9'
    },
    {
      img: stripes10,
      num: 'S10'
    },
    {
      img: stripes11,
      num: 'S11'
    },
    {
      img: stripes12,
      num: 'S12'
    },
    {
      img: stripes13,
      num: 'S13'
    },
    {
      img: stripes14,
      num: 'S14'
    },
    {
      img: stripes15,
      num: 'S15'
    },
    {
      img: stripes16,
      num: 'S16'
    },
    {
      img: stripes17,
      num: 'S17'
    },
    {
      img: stripes18,
      num: 'S18'
    },
    {
      img: asian1,
      num: 'A1'
    },
    {
      img: asian2,
      num: 'A2'
    },
    {
      img: asian3,
      num: 'A3'
    },
    {
      img: asian4,
      num: 'A4'
    },
    {
      img: asian5,
      num: 'A5'
    },
    {
      img: asian6,
      num: 'A6'
    },
    {
      img: asian7,
      num: 'A7'
    },
    {
      img: asian8,
      num: 'A8'
    },
    {
      img: asian9,
      num: 'A9'
    },
    {
      img: asian10,
      num: 'A10'
    },
    {
      img: asian11,
      num: 'A11'
    },
    {
      img: asian12,
      num: 'A12'
    },
    {
      img: asian13,
      num: 'A13'
    },
    {
      img: asian14,
      num: 'A14'
    },
    {
      img: asian15,
      num: 'A15'
    },
    {
      img: asian16,
      num: 'A16'
    },
    {
      img: collectionj1,
      num: 'J1'
    },
    {
      img: collectionj2,
      num: 'J2'
    },
    {
      img: collectionj3,
      num: 'J3'
    },
    {
      img: collectionj4,
      num: 'J4'
    },
    {
      img: collectionj5,
      num: 'J5'
    },
    {
      img: collectionj6,
      num: 'J6'
    },
    {
      img: collectionj7,
      num: 'J7'
    },
    {
      img: collectionj8,
      num: 'J8'
    },
    {
      img: collectionj9,
      num: 'J9'
    },
    {
      img: collectionj10,
      num: 'J10'
    },
    {
      img: collectionj11,
      num: 'J11'
    },
    {
      img: collectionj12,
      num: 'J12'
    },
    {
      img: collectionj13,
      num: 'J13'
    },
    {
      img: collectionj14,
      num: 'J14'
    },
    {
      img: collectionj15,
      num: 'J15'
    },
    {
      img: collectionj16,
      num: 'J16'
    },
    {
      img: collectionj17,
      num: 'J17'
    },
    {
      img: collectionj18,
      num: 'J18'
    },
    {
      img: collectionj19,
      num: 'J19'
    },
    {
      img: collectionj20,
      num: 'J20'
    },
    {
      img: collection1,
      num: 1
    },
    {
      img: collection2,
      num: 2
    },
    {
      img: collection3,
      num: 3
    },
    {
      img: collection4,
      num: 4
    },
    {
      img: collection5,
      num: 5
    },
    {
      img: collection6,
      num: 6
    },
    {
      img: collection7,
      num: 7
    },
    {
      img: collection8,
      num: 8
    },
    {
      img: collection9,
      num: 9
    },
    {
      img: collection10,
      num: 10
    },
    {
      img: collection11,
      num: 11
    },
    {
      img: collection12,
      num: 12
    },
    {
      img: collection13,
      num: 13
    },
    {
      img: collection14,
      num: 14
    },
    {
      img: collection15,
      num: 15
    },
    {
      img: collection16,
      num: 16
    },
    {
      img: collection17,
      num: 17
    },
    {
      img: collection18,
      num: 18
    },
    {
      img: collection19,
      num: 19
    },
    {
      img: collection20,
      num: 20
    },
    {
      img: collection21,
      num: 21
    },
    {
      img: collection22,
      num: 22
    },
    {
      img: collection23,
      num: 23
    },
    {
      img: collection24,
      num: 24
    },
    {
      img: collection25,
      num: 25
    },
    {
      img: collection26,
      num: 26
    },
    {
      img: collection27,
      num: 27
    },
    {
      img: collection28,
      num: 28
    },
    {
      img: collection29,
      num: 29
    },
    {
      img: collection30,
      num: 30
    },
    {
      img: collection31,
      num: 31
    },
    {
      img: collection32,
      num: 32
    },
    {
      img: collection33,
      num: 33
    },
    {
      img: collection34,
      num: 34
    },
    {
      img: collection35,
      num: 35
    },
    {
      img: collection36,
      num: 36
    },
    {
      img: collection37,
      num: 37
    },
    {
      img: collection38,
      num: 38
    },
    {
      img: collection39,
      num: 39
    },
    {
      img: collection40,
      num: 40
    },
    {
      img: collection41,
      num: 41
    },
    {
      img: collection42,
      num: 42
    },
    {
      img: collection43,
      num: 43
    },
    {
      img: collection44,
      num: 44
    },
    {
      img: collection45,
      num: 45
    },
    {
      img: collection46,
      num: 46
    },
    {
      img: collection47,
      num: 47
    },
    {
      img: collection48,
      num: 48
    },
    {
      img: collection49,
      num: 49
    },
    {
      img: collection50,
      num: 50
    },
    {
      img: collection51,
      num: 51
    },
    {
      img: collection52,
      num: 52
    },
    {
      img: collection53,
      num: 53
    },
    {
      img: collection54,
      num: 54
    },
    {
      img: collection55,
      num: 55
    },
    {
      img: collection56,
      num: 56
    },
    {
      img: CEO1,
      num: 'C1'
    },
    {
      img: CEO2,
      num: 'C2'
    },
    {
      img: CEO3,
      num: 'C3'
    },
    {
      img: CEO4,
      num: 'C4'
    },
    {
      img: CEO5,
      num: 'C5'
    },
    {
      img: CEO6,
      num: 'C6'
    },
    {
      img: CEO7,
      num: 'C7'
    },
    {
      img: CEO8,
      num: 'C8'
    },
    {
      img: CEO9,
      num: 'C9'
    },
    {
      img: CEO10,
      num: 'C10'
    },
    {
      img: CEO11,
      num: 'C11'
    },
    {
      img: CEO12,
      num: 'C12'
    },
    {
      img: CEO13,
      num: 'C13'
    },
    {
      img: CEO14,
      num: 'C14'
    },
    {
      img: CEO15,
      num: 'C15'
    },
    {
      img: CEO16,
      num: 'C16'
    },
    {
      img: CEO17,
      num: 'C17'
    },
    {
      img: CEO18,
      num: 'C18'
    },
    {
      img: CEO19,
      num: 'C19'
    },
    {
      img: CEO20,
      num: 'C20'
    }
  ],
  thmartins: [
    {
      img: covenantfashion1,
      num: 'CC1'
    },
    {
      img: covenantfashion2,
      num: 'CC2'
    },
    {
      img: covenantfashion3,
      num: 'CC3'
    },
    {
      img: covenantfashion4,
      num: 'CC4'
    },
    {
      img: covenantfashion5,
      num: 'CC5'
    },
    {
      img: covenantfashion6,
      num: 'CC6'
    },
    {
      img: covenantfashion7,
      num: 'CC7'
    },
    {
      img: covenantfashion8,
      num: 'CC8'
    },
    {
      img: covenantfashion9,
      num: 'CC9'
    },
    {
      img: covenantfashion10,
      num: 'CC10'
    },
    {
      img: covenantfashion11,
      num: 'CC11'
    },
    {
      img: covenantfashion12,
      num: 'CC12'
    },
    {
      img: covenantfashion13,
      num: 'CC13'
    },
    {
      img: covenantfashion14,
      num: 'CC14'
    },
    {
      img: covenantfashion15,
      num: 'CC15'
    },
    {
      img: covenantfashion16,
      num: 'CC16'
    },
    {
      img: covenantfashion17,
      num: 'CC17'
    },
    {
      img: atelier1,
      num: 'AT1'
    },
    {
      img: atelier2,
      num: 'AT2'
    },
    {
      img: atelier3,
      num: 'AT3'
    },
    {
      img: atelier4,
      num: 'AT4'
    },
    {
      img: atelier5,
      num: 'AT5'
    },
    {
      img: atelier6,
      num: 'AT6'
    },
    {
      img: atelier7,
      num: 'AT7'
    },
    {
      img: atelier8,
      num: 'AT8'
    },
    {
      img: atelier9,
      num: 'AT9'
    },
    {
      img: atelier10,
      num: 'AT10'
    },
    {
      img: weeksystem1,
      num: 'WS1'
    },
    {
      img: weeksystem2,
      num: 'WS2'
    },
    {
      img: weeksystem3,
      num: 'WS3'
    },
    {
      img: weeksystem4,
      num: 'WS4'
    },
    {
      img: weeksystem5,
      num: 'WS5'
    },
    {
      img: weeksystem6,
      num: 'WS6'
    },
    {
      img: weeksystem7,
      num: 'WS7'
    },
    {
      img: waiting1,
      num: 'TC1'
    },
    {
      img: waiting2,
      num: 'TC2'
    },
    {
      img: waiting3,
      num: 'TC3'
    },
    {
      img: waiting4,
      num: 'TC4'
    },
    {
      img: waiting5,
      num: 'TC5'
    },
    {
      img: waiting6,
      num: 'TC6'
    },
    {
      img: waiting7,
      num: 'TC7'
    },
    {
      img: waiting8,
      num: 'TC8'
    },
    {
      img: waiting9,
      num: 'TC9'
    },
    {
      img: waiting10,
      num: 'TC10'
    },
    {
      img: waiting11,
      num: 'TC11'
    },
    {
      img: burgundywhite1,
      num: 'BR1'
    },
    {
      img: burgundywhite2,
      num: 'BR2'
    },
    {
      img: burgundywhite3,
      num: 'BR3'
    },
    {
      img: burgundywhite4,
      num: 'BR4'
    },
    {
      img: burgundywhite5,
      num: 'BR5'
    },
    {
      img: burgundywhite6,
      num: 'BR6'
    },
    {
      img: burgundywhite7,
      num: 'BR7'
    },
    {
      img: burgundywhite8,
      num: 'BR8'
    },
    {
      img: burgundywhite9,
      num: 'BR9'
    },
    {
      img: burgundywhite10,
      num: 'BR10'
    },
    {
      img: blackwhite1,
      num: 'BW1'
    },
    {
      img: blackwhite2,
      num: 'BW2'
    },
    {
      img: blackwhite3,
      num: 'BW3'
    },
    {
      img: blackwhite4,
      num: 'BW4'
    },
    {
      img: blackwhite5,
      num: 'BW5'
    },
    {
      img: blackwhite6,
      num: 'BW6'
    },
    {
      img: blackwhite7,
      num: 'BW7'
    },
    {
      img: blackwhite8,
      num: 'BW8'
    },
    {
      img: blackwhite9,
      num: 'BW9'
    },
    {
      img: blackwhite10,
      num: 'BW10'
    },
    {
      img: blackwhite11,
      num: 'BW11'
    },
    {
      img: blackwhite12,
      num: 'BW12'
    },
    {
      img: blackwhite13,
      num: 'BW13'
    },
    {
      img: blackwhite14,
      num: 'BW14'
    },
    {
      img: blackwhite15,
      num: 'BW15'
    },
    {
      img: jeans1,
      num: 'JE1'
    },
    {
      img: jeans2,
      num: 'JE2'
    },
    {
      img: jeans3,
      num: 'JE3'
    },
    {
      img: jeans4,
      num: 'JE4'
    },
    {
      img: jeans5,
      num: 'JE5'
    },
    {
      img: jeans6,
      num: 'JE6'
    },
    {
      img: jeans7,
      num: 'JE7'
    },
    {
      img: jeans8,
      num: 'JE8'
    },
    {
      img: jeans9,
      num: 'JE9'
    },
    {
      img: jeans10,
      num: 'JE10'
    },
    {
      img: contract1,
      num: 'CT1'
    },
    {
      img: contract2,
      num: 'CT2'
    },
    {
      img: contract3,
      num: 'CT3'
    },
    {
      img: contract4,
      num: 'CT4'
    },
    {
      img: contract5,
      num: 'CT5'
    },
    {
      img: contract6,
      num: 'CT6'
    },
    {
      img: contract7,
      num: 'CT7'
    },
    {
      img: contract8,
      num: 'CT8'
    },
    {
      img: contract9,
      num: 'CT9'
    },
    {
      img: contract10,
      num: 'CT10'
    },
    {
      img: private1,
      num: 'P1'
    },
    {
      img: private2,
      num: 'P2'
    },
    {
      img: private3,
      num: 'P3'
    },
    {
      img: private4,
      num: 'P4'
    },
    {
      img: private5,
      num: 'P5'
    },
    {
      img: private6,
      num: 'P6'
    },
    {
      img: private7,
      num: 'P7'
    },
    {
      img: private8,
      num: 'P8'
    },
    {
      img: private9,
      num: 'P9'
    },
    {
      img: private10,
      num: 'P10'
    },
    {
      img: private11,
      num: 'P11'
    },
    {
      img: private12,
      num: 'P12'
    },
    {
      img: private13,
      num: 'P13'
    },
    {
      img: private14,
      num: 'P14'
    },
    {
      img: private15,
      num: 'P15'
    },
    {
      img: private16,
      num: 'P16'
    },
    {
      img: private17,
      num: 'P17'
    },
    {
      img: private18,
      num: 'P18'
    },
    {
      img: private19,
      num: 'P19'
    },
    {
      img: private20,
      num: 'P20'
    },
    {
      img: private21,
      num: 'P21'
    },
    {
      img: private22,
      num: 'P22'
    },
    {
      img: private23,
      num: 'P23'
    },
    {
      img: private24,
      num: 'P24'
    },
    {
      img: private25,
      num: 'P25'
    },
    {
      img: private26,
      num: 'P26'
    },
    {
      img: private27,
      num: 'P27'
    },
    {
      img: private28,
      num: 'P28'
    },
    {
      img: private29,
      num: 'P29'
    },
    {
      img: private30,
      num: 'P30'
    },
    {
      img: private31,
      num: 'P31'
    },
    {
      img: private32,
      num: 'P32'
    },
    {
      img: private33,
      num: 'P33'
    },
    {
      img: private34,
      num: 'P34'
    },
    {
      img: private35,
      num: 'P35'
    },
    {
      img: private36,
      num: 'P36'
    },
    {
      img: private37,
      num: 'P37'
    },
    {
      img: private38,
      num: 'P38'
    },
    {
      img: private39,
      num: 'P39'
    },
    {
      img: private40,
      num: 'P40'
    },
    {
      img: private41,
      num: 'P41'
    },
    {
      img: private42,
      num: 'P42'
    },
    {
      img: private43,
      num: 'P43'
    },
    {
      img: private44,
      num: 'P44'
    },
    {
      img: private45,
      num: 'P45'
    },
    {
      img: private46,
      num: 'P46'
    },
    {
      img: private47,
      num: 'P47'
    },
    {
      img: private48,
      num: 'P48'
    },
    {
      img: private49,
      num: 'P49'
    },
    {
      img: private50,
      num: 'P50'
    }
  ],
  articleEbooks: [
    {
      img: article_30,
      url: '/ebookstore/fashion/impostor/',
      button: 'Download Program',
      service: "Martin's coaching",
      title: 'The Silent Adversary!',
      author: "by G. Martin's & Dr Pamela Kofner",
      invest: `$79`
    },
    {
      img: article_29,
      url: '/ebookstore/fashion/sit',
      button: 'Download Coaching Program',
      service: "Martin's coaching",
      title: 'Colours, posture and manners for female CEOs!',
      author: "by G. Martin's",
      invest: `$25`
    },
    {
      img: coaching_cover,
      url: '/coaching/program/',
      button: 'Download Coaching Program',
      service: "Martin's coaching",
      title: 'The Martin’s House Editorial Business Coaching programme!',
      author: "by G. Martin's",
      invest: `Apply now!`
    },
    {
      img: article_28,
      url: '/ebookstore/fashion/lady',
      button: 'Download E-Book',
      service: "Martin's: download Duology",
      title: 'Diamonds never made a lady!',
      author: "by G. Martin's",
      invest: `$20`
    },
    {
      img: article_27,
      url: '/ebookstore/fashion/trademark',
      button: 'Download E-Book',
      service: "Martin's: download Duology",
      title: 'The trademark as you expected.',
      author: "Couture,<br/>by G. Martin's",
      invest: `$25`
    },
    {
      img: article_26,
      url: '/ebookstore/fashion/london',
      button: 'Download E-Book',
      service: "Martin's: download E-book",
      title: 'Classy casual for business managers.',
      author: "Couture,<br/>by G. Martin's",
      invest: `$20`
    },
    {
      img: article_25,
      url: '/ebookstore/fashion/business/',
      button: 'Download E-Book',
      service: "Martin's: download E-book",
      title: 'The call of boldness for business managers, your time’s now!',
      author: "Business,<br/>by G. Martin's",
      invest: `$15`
    },
    {
      img: article_24,
      url: '/ebookstore/fashion/milliondollar',
      button: 'Download E-Book',
      service: "Martin's: download E-book",
      title: 'The 500 Million Dollar businesswoman.',
      author: "Premium lifestyle,<br/>by G. Martin's",
      invest: `$10`
    },
    {
      img: article_23,
      url: '/ebookstore/fashion/manager',
      button: 'Download E-Book',
      service: "Martin's: download E-book",
      title: 'From business manager to businesswoman (CEO).',
      author: "Business,<br/>by G. Martin's",
      invest: `$10`
    },
    {
      img: article_22,
      url: '/ebookstore/fashion/eternal',
      button: 'Download E-Book',
      service: "Martin's: download E-book",
      title: 'If you dress in yellow, you’ll become glorious and joyful: Why is this colour the ultimate attraction?',
      author: "Premium lifestyle,<br/>by G. Martin's",
      invest: `$15`
    }
  ],
  ebooks: [
    {
      img: fashion_edition_1,
      url: 'https://api.whatsapp.com/send?phone=+447502816932&text=Hello Martin’s,%0a%0aI would like to order the e-book “The modern mini dress-coat for empowered women"%0aMy details are:%0a%0aName: [Type here]%0a%0aEmail: [Type here]%0a%0aPhone Number: [Type here]',
      button: 'Download E-Book',
      invest: `Investment - $${investFashion}`
    },
    {
      img: fashion_edition_2,
      url: 'https://api.whatsapp.com/send?phone=+447502816932&text=Hello Martin’s,%0a%0aI would like to order the e-book “The coloured blocked blazer mini dress"%0aMy details are:%0a%0aName: [Type here]%0a%0aEmail: [Type here]%0a%0aPhone Number: [Type here]',
      button: 'Download E-Book',
      invest: `Investment - $${investFashion}`
    },
    {
      img: fashion_edition_3,
      url: 'https://api.whatsapp.com/send?phone=+447502816932&text=Hello Martin’s,%0a%0aI would like to order the e-book “The art of architectural elegance in a blazer dress"%0aMy details are:%0a%0aName: [Type here]%0a%0aEmail: [Type here]%0a%0aPhone Number: [Type here]',
      button: 'Download E-Book',
      invest: `Investment - $${investFashion}`
    },
    {
      img: fashion_edition_4,
      url: 'https://api.whatsapp.com/send?phone=+447502816932&text=Hello Martin’s,%0a%0aI would like to order the e-book “The poetic power of sartorial storytelling."%0aMy details are:%0a%0aName: [Type here]%0a%0aEmail: [Type here]%0a%0aPhone Number: [Type here]',
      button: 'Download E-Book',
      invest: `Investment - $${investFashion}`
    },
    {
      img: beauty_edition_1,
      url: 'https://api.whatsapp.com/send?phone=+447502816932&text=Hello Martin’s,%0a%0aI would like to order the e-book “Eye makeup trends that celebs are wearing will blow your mind."%0aMy details are:%0a%0aName: [Type here]%0a%0aEmail: [Type here]%0a%0aPhone Number: [Type here]',
      button: 'Download E-Book',
      invest: `Investment - $${investFashion}`
    }
  ],
  edition_1: [
    {
      img: fashion_edition_1
    },
    {
      img: one
    },
    {
      img: two
    },
    {
      img: three
    },
    {
      img: four
    },
    {
      img: five
    }
  ],
  phoneNumber: [
    {
      number: '+447502816932',
      priceSize: '16px',
      price: investPrice,
      priceFashion: investFashion,
      priceLookbook: investCollection
    }
  ]
};
